import axios from "axios";
import * as XLSX from "xlsx";
import Modal from "react-modal";
import { DatePicker } from "rsuite";
import moment from "moment-timezone";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Invoices.css";
import { ReactComponent as FilterIcon } from "../../images/icons/filterIcon.svg";
import { ReactComponent as ItemIcon } from "../../images/icons/itemIcon.svg";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { saveAs } from "file-saver";
import invStatus from "../../constants/invStatus";
import InvoiceModal from "./elements/invoiceModal";
import PaymentStatus from "./elements/paymentStatus";
import { useSelector, useDispatch } from "react-redux";
import { renderCTA } from "../../helpers/invoiceHelpers";
import invPaymStatus from "../../constants/invPaymStatus";
import React, { useState, useRef, useEffect, useReducer, useMemo, useCallback } from "react";
import PaymentStatusWise from "./elements/paymentStatusWise";
import invStatusConsts from "../../constants/invStatusConsts";
import { logout, reset } from "../../features/auth/authSlice";
import { setHeaderText } from "../../features/headerText/headerTextSlice";
import { reset as invoiceReset } from "../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset, setAppLoading } from "../../features/appSettings/appSettingsSlice.js";
import Calendar from "../../helpers/dateComponents/Calendar";
import isEqual from "lodash/isEqual";
import userTypeConsts from "../../constants/userTypeConsts.js";
import { useGetTeams } from "../TimeTracker/TimeTrackerOverview/useTimeTracker.jsx";
import TruncateFilterFieldView from "../helpers/truncateFilterFieldView.js";
import { useFetchInvoices } from "./services.js";
import { motion } from 'framer-motion';
import JSZip from 'jszip';
import { filterReducer, initialFilterState } from "./InvoiceComponents/reducers/filterReducer.js";
import { uiReducer, initialUIState } from "./InvoiceComponents/reducers/uiReducer.js";
import { selectionReducer, initialSelectionState } from "./InvoiceComponents/reducers/selectionReducer.js";
import { loadingReducer, initialLoadingState } from "./InvoiceComponents/reducers/loadingReducer.js";
import { handleInvoiceError, handleUserDeletionError, handleExportError, handleDownloadError } from "./InvoiceComponents/utils/invoiceErrorHandler.js";
import { InvoiceTableSkeleton } from "./InvoiceComponents/SkeletonLoader.jsx";
import { filterUsersByFullName, filterPaymentStatusByText } from "./InvoiceComponents/utils/searchFilterUtils.js";
import { useDropdownHandlers, useToggleDropdown } from "./InvoiceComponents/hooks/useDropdownHandlers.js";


const DEFAULT_AVATAR = "/uploads/lowProfileImage/user_default.png";

const MemberAvatar = ({ src, alt }) => {
  const [imgSrc, setImgSrc] = React.useState(src || DEFAULT_AVATAR);

  React.useEffect(() => {
    setImgSrc(src || DEFAULT_AVATAR);
  }, [src]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className="member-image"
      onError={() => setImgSrc(DEFAULT_AVATAR)}
    />
  );
};

const renderImage = (rowData) => {
  return (
    <img
      src={require("../../images/brand-logos/brand_logo.svg").default}
      alt="App"
    />
  );
};

const timeZone = global?.config?.getTimeZone();
// console.log("timeZone", timeZone);
// console.log("startofDay", moment.tz(timeZone && timeZone).startOf("day").toDate())

const ranges = [
  {
    label: "Today",
    value: moment.tz(timeZone).startOf("day").toDate(), // Start of today in the given timezone
  },
];

const MobileSortIcon = () => (
  <span className="mobile-sort-icon-custom sort-icon-wrap" style={{ display: 'inline-flex', flexDirection: 'column', gap: '2px', alignItems: 'center', justifyContent: 'center', marginLeft: '6px', verticalAlign: 'middle', lineHeight: 1, flexShrink: 0 }}>
    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', color: '#405BFF', opacity: 1 }}>
      <path d="M1 4L4 1L7 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', color: '#405BFF', opacity: 1 }}>
      <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </span>
);

const Invoices2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth <= 767);
  const [isMobileSheet, setIsMobileSheet] = useState(() => typeof window !== 'undefined' && window.innerWidth <= 767);
  const [openMobileAccordion, setOpenMobileAccordion] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
      setIsMobileSheet(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMvp = process.env.NODE_ENV === 'mvp' || process.env.REACT_APP_ENV_TYPE === 'mvp' || process.env.REACT_APP_NODE_ENV === 'mvp';
  const isMvpMobile = isMvp && isMobile;


  // Data state (kept as useState as they're managed by useInvoiceData hook)
  const [products, setProducts] = useState([]);
  const [total, setTotal] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState(null);
  const [sortDir, setSortDir] = useState('desc');
  const [invStatusList, setInvStatusList] = useState([]);
  const [invPaymStatusList, setInvPaymStatusList] = useState([]);
  const [isTypeExiting, setIsTypeExiting] = useState(false);


  // Reducers for consolidated state management
  const [filterState, dispatchFilter] = useReducer(filterReducer, initialFilterState);
  const [uiState, dispatchUI] = useReducer(uiReducer, initialUIState);
  const [selectionState, dispatchSelection] = useReducer(selectionReducer, initialSelectionState);
  const [loadingState, dispatchLoading] = useReducer(loadingReducer, initialLoadingState);

  // Refs for dropdowns and calendars
  const calendarRef = useRef(null);
  const calendarModalRef = useRef(null);
  const teamDropdownRef = useRef(null);
  const teamModalDropdownRef = useRef(null);
  const paymentStatusDropdownRef = useRef(null);
  const paymentStatusModalDropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);
  const statusModalDropdownRef = useRef(null);
  const invTypeDropdownRef = useRef(null);
  const invTypeModalDropdownRef = useRef(null);
  const showingDropdownRef = useRef(null);
  const timeTableRef = useRef(null);
  const prevTeamsRef = useRef(null);
  const prevInvStatusListRef = useRef(null);
  const prevInvPaymStatusListRef = useRef(null);
  const prevSelectedTeamsRef = useRef(null);
  const prevSelectedStatusRef = useRef(null);
  const prevSelectedPaymentStatusRef = useRef(null);
  const prevSelectedInvTypesRef = useRef(null);
  const prevInvoicesRef = useRef(null);
  const prevInvoiceTotalRef = useRef(null);

  useEffect(() => {
    const tableEl = timeTableRef.current;
    const contentOuter = document.querySelector(".content-outer.Invoices");
    if (!isMobile || !tableEl || !contentOuter) {
      contentOuter?.classList.remove("invoices-hscroll-end");
      return undefined;
    }

    let atEnd = false;
    const updatePadding = () => {
      if (window.innerWidth > 767) {
        atEnd = false;
        contentOuter.classList.remove("invoices-hscroll-end");
        return;
      }
      const maxScroll = Math.max(0, tableEl.scrollWidth - tableEl.clientWidth);
      if (maxScroll <= 2) {
        atEnd = false;
        contentOuter.classList.remove("invoices-hscroll-end");
        return;
      }
      if (!atEnd && tableEl.scrollLeft >= maxScroll - 4) {
        atEnd = true;
        contentOuter.classList.add("invoices-hscroll-end");
      } else if (atEnd && tableEl.scrollLeft < maxScroll - 24) {
        atEnd = false;
        contentOuter.classList.remove("invoices-hscroll-end");
      }
    };

    tableEl.addEventListener("scroll", updatePadding, { passive: true });
    window.addEventListener("resize", updatePadding);
    const resizeObserver =
      typeof ResizeObserver !== "undefined" ? new ResizeObserver(updatePadding) : null;
    resizeObserver?.observe(tableEl);
    updatePadding();

    return () => {
      tableEl.removeEventListener("scroll", updatePadding);
      window.removeEventListener("resize", updatePadding);
      resizeObserver?.disconnect();
      contentOuter.classList.remove("invoices-hscroll-end");
    };
  }, [isMobile, products]);

  const { appSettings } = useSelector((state) => state.appSettings);

  // Destructure filter state for easier access
  const {
    selectedDate,
    paymentStatusFilter,
    statusFilter,
    invTypeFilter,
    userFilter,
    invoiceNumberFilter,
    invNumFilter,
    debouncedValue,
    dateRange,
    selectAllTeam,
    selectedTeams,
    userSearchTerm,
    selectAllStatus,
    selectedStatus,
    selectAllPaymentStatus,
    selectedPaymentStatus,
    paymentStatusSearchTerm,
    selectedInvTypes,
    selectAllInvType,
  } = filterState;

  // Destructure UI state
  const {
    invoiceTypeModalIsOpen,
    userSelectModal,
    isAutomaticInv,
    showFilterModal,
    showConfirmationModal,
    isTeamDropdownOpen,
    isTeamModalDropdownOpen,
    isStatusDropdownOpen,
    isStatusModalDropdownOpen,
    isPaymentStatusDropdownOpen,
    isPaymentStatusModalDropdownOpen,
    isInvTypeDropdownOpen,
    isInvTypeModalDropdownOpen,
    showCalendar,
    showModalCalendar,
    showingDropdownOpen,
  } = uiState;

  // Destructure selection state
  const {
    selectAll,
    lastSelectedRowIndex,
    selectAllByPage,
    selectedRows,
  } = selectionState;

  // Destructure loading state
  const {
    isLoadingDownload,
    isExportLoading,
  } = loadingState;

  // Helper functions for backward compatibility with existing setters
  const setSelectedDate = (date) => {
    dispatchFilter({ type: 'SET_SELECTED_DATE', payload: date });
    setCurrentPage(1);
  };

  const setPaymentStatusFilter = (value) => dispatchFilter({ type: 'SET_PAYMENT_STATUS_FILTER', payload: value });
  const setStatusFilter = (value) => dispatchFilter({ type: 'SET_STATUS_FILTER', payload: value });
  const setInvTypeFilter = (value) => dispatchFilter({ type: 'SET_INV_TYPE_FILTER', payload: value });
  const setUserFilter = (value) => dispatchFilter({ type: 'SET_USER_FILTER', payload: value });
  const setInvoiceNumberFilter = (value) => dispatchFilter({ type: 'SET_INVOICE_NUMBER_FILTER', payload: value });
  const setInvNumFilter = (value) => dispatchFilter({ type: 'SET_INV_NUM_FILTER', payload: value });
  const setDebouncedValue = (value) => dispatchFilter({ type: 'SET_DEBOUNCED_VALUE', payload: value });
  const setDateRange = (value) => dispatchFilter({ type: 'SET_DATE_RANGE', payload: value });
  const setSelectedTeams = (value) => {
    dispatchFilter({ type: 'SET_SELECTED_TEAMS', payload: value });
    setCurrentPage(1);
  };
  const setSelectAllTeam = (value) => dispatchFilter({ type: 'SET_SELECT_ALL_TEAM', payload: value });
  const setUserSearchTerm = (value) => dispatchFilter({ type: 'SET_USER_SEARCH_TERM', payload: value });
  const setSelectedStatus = (value) => {
    dispatchFilter({ type: 'SET_SELECTED_STATUS', payload: value });
    setCurrentPage(1);
  };
  const setSelectAllStatus = (value) => dispatchFilter({ type: 'SET_SELECT_ALL_STATUS', payload: value });
  const setSelectedPaymentStatus = (value) => {
    dispatchFilter({ type: 'SET_SELECTED_PAYMENT_STATUS', payload: value });
    setCurrentPage(1);
  };
  const setSelectAllPaymentStatus = (value) => dispatchFilter({ type: 'SET_SELECT_ALL_PAYMENT_STATUS', payload: value });
  const setPaymentStatusSearchTerm = (value) => dispatchFilter({ type: 'SET_PAYMENT_STATUS_SEARCH_TERM', payload: value });
  const setSelectedInvTypes = (value) => {
    dispatchFilter({ type: 'SET_SELECTED_INV_TYPES', payload: value });
    setCurrentPage(1);
  };
  const setSelectAllInvType = (value) => dispatchFilter({ type: 'SET_SELECT_ALL_INV_TYPE', payload: value });

  // UI state setters (only those used directly, others use dispatchUI directly)
  const setInvoiceTypeModalIsOpen = (value) => dispatchUI({ type: 'SET_INVOICE_TYPE_MODAL_OPEN', payload: value });
  const setUserSelectModal = (value) => dispatchUI({ type: 'SET_USER_SELECT_MODAL', payload: value });
  const setIsAutomaticInv = (value) => dispatchUI({ type: 'SET_IS_AUTOMATIC_INV', payload: value });
  const setShowFilterModal = (value) => dispatchUI({ type: 'SET_SHOW_FILTER_MODAL', payload: value });
  const setShowCalendar = (value) => dispatchUI({ type: 'SET_SHOW_CALENDAR', payload: value });
  const setShowModalCalendar = (value) => dispatchUI({ type: 'SET_SHOW_MODAL_CALENDAR', payload: value });
  const setShowingDropdownOpen = (value) => dispatchUI({ type: 'SET_SHOWING_DROPDOWN_OPEN', payload: value });

  // Selection state setters
  const setSelectAll = (value) => dispatchSelection({ type: 'SET_SELECT_ALL', payload: value });
  const setLastSelectedRowIndex = (value) => dispatchSelection({ type: 'SET_LAST_SELECTED_ROW_INDEX', payload: value });
  const setSelectAllByPage = (value) => dispatchSelection({ type: 'SET_SELECT_ALL_BY_PAGE', payload: value });
  const setSelectedRows = (value) => dispatchSelection({ type: 'SET_SELECTED_ROWS', payload: value });

  // Loading state setters
  const setIsLoadingDownload = (value) => dispatchLoading({ type: 'SET_IS_LOADING_DOWNLOAD', payload: value });
  const setIsExportLoading = (value) => dispatchLoading({ type: 'SET_IS_EXPORT_LOADING', payload: value });

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setCurrentPage(1);
  };

  let token = null;
  const { user } = useSelector((state) => state.auth);
  const dashboradDate = useSelector((state) => state.invoice.dashboardDateRange);
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }
  const params = new URLSearchParams(location.search);
  const monthNumber = params.get("month");
  const dashboardDate = useSelector((state) => state.invoice.dashboardDateRange);
  const thirtyYearsAgo = new Date(moment().utc().subtract(30, 'years').startOf('year').format()).toISOString();

  let invStartDate, invEndDate;
  if (Array.isArray(dateRange) && dateRange.length === 2) {
    invStartDate = dateRange[0];
    invEndDate = dateRange[1];
  } else if (monthNumber) {
    const year =
      dashboardDate?.[1] && dashboardDate[0] !== thirtyYearsAgo
        ? new Date(dashboardDate[1]).getFullYear()
        : new Date().getFullYear();

    const monthStart = moment
      .tz([year, monthNumber - 1, 1], global.config.getTimeZone())
      .startOf("day")
      .toDate();
    const monthEnd = moment
      .tz([year, monthNumber - 1], global.config.getTimeZone())
      .endOf("month")
      .endOf("day")
      .toDate();

    if (dashboardDate?.length === 2) {
      const dashStart = new Date(moment(dashboradDate[0]).tz(global.config.getTimeZone()).startOf('day')).toISOString();
      const dashEnd = new Date(moment(dashboradDate[1]).tz(global.config.getTimeZone()).endOf('day')).toISOString();
      invStartDate = dashStart >= monthStart.toISOString() ? dashStart : monthStart.toISOString();
      invEndDate = dashEnd <= monthEnd.toISOString() ? dashEnd : monthEnd.toISOString();
    } else {
      invStartDate = monthStart.toISOString();
      invEndDate = monthEnd.toISOString();
    }
  } else {
    invStartDate = null;
    invEndDate = null;
  }

  const reimbursementInvoiceType = useSelector((state) => state.invoice.invoiceType);
  const tz = useSelector((state) => state.appSettings.appSettings.timeZone);
  const { data: teams = [], isLoading: teamLoading } = useGetTeams(token);
  const {
    data: invoiceData = { invoices: [], total: 0 },
    isLoading: invoicesLoading,
    isFetching: invoicesFetching,
    error,
    refetch: refetchInvoices,
  } = useFetchInvoices({
    startDate: invStartDate ? invStartDate : null,
    endDate: invEndDate ? invEndDate : null,
    token,
    invNumber: invNumFilter || "",
    invTypes: invTypeFilter,
    invCreatedDates: Array.isArray(dateRange) && dateRange.length === 2
      ? [new Date(dateRange[0]).toISOString(), new Date(dateRange[1]).toISOString()]
      : null,
    invDueDates: selectedDate ? [selectedDate.toISOString()] : null,
    invStatuses: statusFilter,
    invPaymentStatuses: paymentStatusFilter,
    userIds: userFilter,
    tz,
    page: currentPage,
    limit: rowsPerPage,
    sortBy: sortField,
    sortDirection: sortDir,
  });
  const { invoices } = invoiceData;
  const invoiceTotal = invoiceData.total

  // Memoize handleUserDeletion to prevent unnecessary re-creations
  const handleUserDeletion = useCallback(() => {
    localStorage.removeItem("user");
    dispatch(logout());
    dispatch(reset());
    dispatch(invoiceReset());
    dispatch(headerReset());
    dispatch(appSettingsReset());
    toast.error("This user is deleted!", {
      position: "bottom-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    navigate("/");
  }, [dispatch, navigate]);

  // Effect for loading state - only depends on invoicesLoading
  useEffect(() => {
    dispatch(setAppLoading(invoicesLoading));
  }, [invoicesLoading, dispatch]);

  // Effect for initial setup - only runs on mount or when location changes
  useEffect(() => {
    setInvStatusList(invStatus.inv_status);
    setInvPaymStatusList(invPaymStatus.inv_paym_status);
    dispatch(setHeaderText("Invoices"));

    // Only refetch when navigating back from an invoice action (create/edit/delete)
    // location.state?.fromInvoiceAction is set by those pages on navigate()
    if (location.state?.fromInvoiceAction) {
      refetchInvoices();
    }
  }, [dispatch, location.pathname, location.search, location.state, refetchInvoices]);

  // Effect for updating products and total - separate from error handling
  useEffect(() => {
    // Check if values have actually changed
    const invoicesString = JSON.stringify(invoices);
    const invoicesChanged = prevInvoicesRef.current !== invoicesString;
    const totalChanged = prevInvoiceTotalRef.current !== invoiceTotal;

    if (invoicesChanged || totalChanged) {
      prevInvoicesRef.current = invoicesString;
      prevInvoiceTotalRef.current = invoiceTotal;

      if (invoices && invoiceTotal !== undefined) {
        setProducts(invoices);
        setTotal(invoiceTotal);
      } else {
        setProducts([]);
        setTotal(0);
      }
    }
  }, [invoices, invoiceTotal]);

  // Effect for error handling - separate from data updates
  useEffect(() => {
    if (error) {
      if (error.response?.data?.status === "deleted") {
        handleUserDeletionError(handleUserDeletion);
      } else {
        handleInvoiceError(error, "fetching invoices");
      }
    }
  }, [error, handleUserDeletion]);

  // Note: Manual refetch calls removed - React Query automatically refetches when query key changes
  // The query key in useFetchInvoices includes all filter parameters (startDate, endDate, invNumber, 
  // invTypes, invCreatedDates, invDueDates, invStatuses, invPaymentStatuses, userIds, tz, page, limit)
  // When any of these change, React Query will automatically refetch the data

  useEffect(() => {
    const handler = setTimeout(() => {
      setInvNumFilter(debouncedValue);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [debouncedValue]);

  // Note: Client-side filtering logic was removed as filtering is handled server-side via useFetchInvoices hook
  // If client-side filtering is needed in the future, use the optimized filter utilities from:
  // InvoiceComponents/utils/invoiceFilterUtils.js
  // These utilities use early returns and are broken down into smaller, testable functions for better performance
  const renderAmount = (rowData) => {
    var totalAmount = rowData.inv_total_amount.toLocaleString("en-US", {
      style: "currency",
      currency: rowData.inv_currency,
    });

    return <span> {totalAmount}</span>;
  };

  // Consolidated dropdown handlers using reusable hook
  const teamDropdownHandlers = useDropdownHandlers({
    items: teams,
    selectedItems: selectedTeams,
    setSelectedItems: setSelectedTeams,
    setSelectAll: setSelectAllTeam,
    selectAll: selectAllTeam,
    getItemId: (team) => team._id,
    setCurrentPage,
  });
  const handleCheckboxTeamChange = teamDropdownHandlers.handleCheckboxChange;
  const handleSelectAllTeamChange = teamDropdownHandlers.handleSelectAllChange;

  // Consolidated user filtering using reusable utility
  const filteredUsers = useMemo(() => {
    return filterUsersByFullName(teams, userSearchTerm);
  }, [teams, userSearchTerm]);

  const handleUserSearchChange = (e) => {
    setUserSearchTerm(e.target.value);
  };

  useEffect(() => {
    // Check if values have actually changed
    const teamsString = JSON.stringify(teams);
    const selectedTeamsString = JSON.stringify(selectedTeams);
    const currentKey = `${teamsString}-${selectedTeamsString}`;
    const prevKey = prevSelectedTeamsRef.current;

    if (prevKey !== currentKey) {
      prevSelectedTeamsRef.current = currentKey;
      setSelectAllTeam(selectedTeams.length === teams.length);
      setUserFilter(selectedTeams.length === teams.length ? teams.map((team) => team._id) : selectedTeams);
    }
  }, [selectedTeams, teams]);

  // Consolidated toggle handlers using reusable hook
  const toggleTeamDropdown = useToggleDropdown(
    () => dispatchUI({ type: 'TOGGLE_TEAM_DROPDOWN' }),
    setUserSearchTerm
  );

  const toggleTeamModalDropdown = useToggleDropdown(
    () => dispatchUI({ type: 'TOGGLE_TEAM_MODAL_DROPDOWN' }),
    setUserSearchTerm
  );

  // Consolidated dropdown handlers using reusable hook
  const statusDropdownHandlers = useDropdownHandlers({
    items: invStatusList,
    selectedItems: selectedStatus,
    setSelectedItems: setSelectedStatus,
    setSelectAll: setSelectAllStatus,
    selectAll: selectAllStatus,
    getItemId: (status) => status._id,
    setCurrentPage,
  });
  const handleCheckboxStatusChange = statusDropdownHandlers.handleCheckboxChange;
  const handleSelectAllStatusChange = statusDropdownHandlers.handleSelectAllChange;

  useEffect(() => {
    // Check if values have actually changed
    const invStatusListString = JSON.stringify(invStatusList);
    const selectedStatusString = JSON.stringify(selectedStatus);
    const currentKey = `${invStatusListString}-${selectedStatusString}`;
    const prevKey = prevSelectedStatusRef.current;

    if (prevKey !== currentKey) {
      prevSelectedStatusRef.current = currentKey;
      setSelectAllStatus(selectedStatus.length === invStatusList.length);
      setStatusFilter(selectedStatus.length === invStatusList.length ? invStatusList.map((status) => status._id) : selectedStatus);
    }
  }, [selectedStatus, invStatusList]);


  // Consolidated toggle handlers using reusable hook
  const toggleStatusDropdown = useToggleDropdown(
    () => dispatchUI({ type: 'TOGGLE_STATUS_DROPDOWN' }),
    null // No search term to clear
  );

  const toggleStatusModalDropdown = useToggleDropdown(
    () => dispatchUI({ type: 'TOGGLE_STATUS_MODAL_DROPDOWN' }),
    null // No search term to clear
  );

  // Consolidated dropdown handlers using reusable hook
  const paymentStatusDropdownHandlers = useDropdownHandlers({
    items: invPaymStatusList,
    selectedItems: selectedPaymentStatus,
    setSelectedItems: setSelectedPaymentStatus,
    setSelectAll: setSelectAllPaymentStatus,
    selectAll: selectAllPaymentStatus,
    getItemId: (paymentstatus) => paymentstatus._id,
    setCurrentPage,
  });
  const handleCheckboxPaymentStatusChange = paymentStatusDropdownHandlers.handleCheckboxChange;
  const handleSelectAllPaymentStatusChange = paymentStatusDropdownHandlers.handleSelectAllChange;

  // Consolidated payment status filtering using reusable utility
  const filteredInvPaymStatusList = useMemo(() => {
    return filterPaymentStatusByText(invPaymStatusList, paymentStatusSearchTerm);
  }, [invPaymStatusList, paymentStatusSearchTerm]);

  const handlePaymentStatusSearchChange = (e) => {
    setPaymentStatusSearchTerm(e.target.value);
  };

  useEffect(() => {
    // Check if values have actually changed
    const invPaymStatusListString = JSON.stringify(invPaymStatusList);
    const selectedPaymentStatusString = JSON.stringify(selectedPaymentStatus);
    const currentKey = `${invPaymStatusListString}-${selectedPaymentStatusString}`;
    const prevKey = prevSelectedPaymentStatusRef.current;

    if (prevKey !== currentKey) {
      prevSelectedPaymentStatusRef.current = currentKey;
      setSelectAllPaymentStatus(selectedPaymentStatus.length === invPaymStatusList.length);
      setPaymentStatusFilter(
        selectedPaymentStatus.length === invPaymStatusList.length
          ? invPaymStatusList.map((paymentstatus) => paymentstatus._id)
          : selectedPaymentStatus
      );
    }
  }, [selectedPaymentStatus, invPaymStatusList]);

  // Consolidated toggle handlers using reusable hook
  const togglePaymentStatusDropdown = useToggleDropdown(
    () => dispatchUI({ type: 'TOGGLE_PAYMENT_STATUS_DROPDOWN' }),
    setPaymentStatusSearchTerm
  );

  const togglePaymentStatusModalDropdown = useToggleDropdown(
    () => dispatchUI({ type: 'TOGGLE_PAYMENT_STATUS_MODAL_DROPDOWN' }),
    setPaymentStatusSearchTerm
  );

  // Consolidated toggle handlers using reusable hook
  const toggleInvTypeDropdown = useToggleDropdown(
    () => dispatchUI({ type: 'TOGGLE_INV_TYPE_DROPDOWN' }),
    null // No search term to clear
  );

  const toggleInvTypeModalDropdown = useToggleDropdown(
    () => dispatchUI({ type: 'TOGGLE_INV_TYPE_MODAL_DROPDOWN' }),
    null // No search term to clear
  );

  // Invoice type dropdown handlers (special case: uses hardcoded values instead of items array)
  const handleCheckboxInvTypeChange = useCallback((invType) => {
    const updatedSelection = [...selectedInvTypes];
    const index = updatedSelection.indexOf(invType);

    if (index === -1) {
      updatedSelection.push(invType);
    } else {
      updatedSelection.splice(index, 1);
    }
    setCurrentPage(1);
    setSelectedInvTypes(updatedSelection);
  }, [selectedInvTypes, setCurrentPage]);

  const handleSelectAllInvTypeChange = useCallback(() => {
    const allInvTypes = ["Regular", "Reimbursement"];
    const newSelection = selectAllInvType ? [] : allInvTypes;
    setCurrentPage(1);
    setSelectedInvTypes(newSelection);
    setSelectAllInvType(!selectAllInvType);
  }, [selectAllInvType, setCurrentPage]);

  useEffect(() => {
    // Check if values have actually changed
    const selectedInvTypesString = JSON.stringify(selectedInvTypes);
    const prevKey = prevSelectedInvTypesRef.current;

    if (prevKey !== selectedInvTypesString) {
      prevSelectedInvTypesRef.current = selectedInvTypesString;
      setSelectAllInvType(selectedInvTypes.length === 2);
      setInvTypeFilter(
        selectedInvTypes.length === 2 ? ["Regular", "Reimbursement"] : selectedInvTypes
      );
    }
  }, [selectedInvTypes]);

  const onDateChange = (ranges) => {
    if (ranges === null) {
      setDateRange(null);
      setCurrentPage(1);
      setShowCalendar(false);
      setShowModalCalendar(false);
      return;
    }
    const startOfDayUTC = moment.tz(moment(ranges.startDate).format('YYYY-MM-DD'), global.config.getTimeZone()).startOf("day").toDate();
    const endOfDayUTC = moment.tz(moment(ranges.endDate).format('YYYY-MM-DD'), global.config.getTimeZone()).endOf("day").toDate();
    setDateRange([startOfDayUTC, endOfDayUTC]);
    setCurrentPage(1);
    setShowCalendar(false);
    setShowModalCalendar(false);
  };

  const toggleCalendar = () => {
    dispatchUI({ type: 'TOGGLE_CALENDAR' });
  };

  const cancelCalendar = () => {
    dispatchUI({ type: 'SET_SHOW_CALENDAR', payload: false });
  };

  const toggleModalCalendar = () => {
    dispatchUI({ type: 'TOGGLE_MODAL_CALENDAR' });
  };

  const cancelModalCalendar = () => {
    dispatchUI({ type: 'SET_SHOW_MODAL_CALENDAR', payload: false });
  };

  const handleClickOutsideDropdown = useCallback((event) => {
    const isClickInsideTeamDropdown =
      teamDropdownRef.current && teamDropdownRef.current.contains(event.target);
    const isClickInsideTeamModalDropdown =
      teamModalDropdownRef.current && teamModalDropdownRef.current.contains(event.target);
    const isClickInsidePaymentStatusDropdown =
      paymentStatusDropdownRef.current &&
      paymentStatusDropdownRef.current.contains(event.target);
    const isClickInsidePaymentStatusModalDropdown =
      paymentStatusModalDropdownRef.current &&
      paymentStatusModalDropdownRef.current.contains(event.target);
    const isClickInsideStatusDropdown =
      statusDropdownRef.current &&
      statusDropdownRef.current.contains(event.target);
    const isClickInsideStatusModalDropdown =
      statusModalDropdownRef.current &&
      statusModalDropdownRef.current.contains(event.target);
    const isClickInsideInvTypeDropdown =
      invTypeDropdownRef.current &&
      invTypeDropdownRef.current.contains(event.target);
    const isClickInsideInvTypeModalDropdown =
      invTypeModalDropdownRef.current &&
      invTypeModalDropdownRef.current.contains(event.target);
    const isClickInsideshowingDropdown =
      showingDropdownRef.current &&
      showingDropdownRef.current.contains(event.target);
    const isClickInsideCalendarDropdown = calendarRef.current && calendarRef.current.contains(event.target);
    const isClickInsideModalCalendarDropdown = calendarModalRef.current && calendarModalRef.current.contains(event.target);
    if (!isClickInsideTeamDropdown) {
      dispatchUI({ type: 'SET_TEAM_DROPDOWN_OPEN', payload: false });
    }
    if (!isClickInsideTeamModalDropdown) {
      dispatchUI({ type: 'SET_TEAM_MODAL_DROPDOWN_OPEN', payload: false });
    }
    if (!isClickInsideStatusDropdown) {
      dispatchUI({ type: 'SET_STATUS_DROPDOWN_OPEN', payload: false });
    }
    if (!isClickInsideStatusModalDropdown) {
      dispatchUI({ type: 'SET_STATUS_MODAL_DROPDOWN_OPEN', payload: false });
    }
    if (!isClickInsidePaymentStatusDropdown) {
      dispatchUI({ type: 'SET_PAYMENT_STATUS_DROPDOWN_OPEN', payload: false });
    }
    if (!isClickInsidePaymentStatusModalDropdown) {
      dispatchUI({ type: 'SET_PAYMENT_STATUS_MODAL_DROPDOWN_OPEN', payload: false });
    }
    if (!isClickInsideInvTypeDropdown) {
      dispatchUI({ type: 'SET_INV_TYPE_DROPDOWN_OPEN', payload: false });
    }
    if (!isClickInsideInvTypeModalDropdown) {
      dispatchUI({ type: 'SET_INV_TYPE_MODAL_DROPDOWN_OPEN', payload: false });
    }
    if (!isClickInsideshowingDropdown) {
      dispatchUI({ type: 'SET_SHOWING_DROPDOWN_OPEN', payload: false });
    }
    if (!isClickInsideCalendarDropdown) {
      dispatchUI({ type: 'SET_SHOW_CALENDAR', payload: false });
    }
    if (!isClickInsideModalCalendarDropdown) {
      dispatchUI({ type: 'SET_SHOW_MODAL_CALENDAR', payload: false });
    }
  }, [dispatchUI]);

  useEffect(() => {
    // Add event listener for click outside dropdown
    document.addEventListener("click", handleClickOutsideDropdown);

    // Cleanup function to remove the event listener
    return () => {
      document.removeEventListener("click", handleClickOutsideDropdown);
    };
  }, [handleClickOutsideDropdown]);

  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const clearFilters = () => {
    dispatchFilter({ type: 'CLEAR_FILTERS' });
    // Reset to defaults - these will be set by useEffect hooks
    setSelectedTeams(teams.map((team) => team._id));
    setSelectedStatus(invStatusList.map((status) => status._id));
    setSelectedPaymentStatus(
      invPaymStatusList.map((paymentstatus) => paymentstatus._id)
    );
    setSelectedInvTypes(["Regular", "Reimbursement"]);
    dispatchUI({ type: 'SET_SHOW_FILTER_MODAL', payload: false });
  };

  const checkAndShowConfirmationModal = () => {
    const isInvNumModified = !isEqual(invNumFilter, "");
    const isTeamsModified = !isEqual(selectedTeams, teams.map((team) => team._id));
    const isStatusModified = !isEqual(selectedStatus, invStatusList.map((status) => status._id));
    const isPaymentStatusModified = !isEqual(selectedPaymentStatus, invPaymStatusList.map((paymentstatus) => paymentstatus._id));
    const isDueDateModified = !isEqual(selectedDate, null);
    const isInvTypeModified = !isEqual(selectedInvTypes, ["Regular", "Reimbursement"]);

    const isDateRangeModified = !isEqual(dateRange, null);

    if (
      isInvNumModified ||
      isTeamsModified ||
      isStatusModified ||
      isPaymentStatusModified ||
      isDueDateModified ||
      isInvTypeModified ||
      isDateRangeModified
    ) {
      dispatchUI({ type: 'SET_SHOW_CONFIRMATION_MODAL', payload: true });
    } else {
      dispatchUI({ type: 'SET_SHOW_FILTER_MODAL', payload: false });
    }
  };

  const handleCancel = () => {
    dispatchUI({ type: 'SET_SHOW_CONFIRMATION_MODAL', payload: false });
  };

  const handleApplyConfirm = () => {
    dispatchUI({ type: 'SET_SHOW_CONFIRMATION_MODAL', payload: false });
    dispatchUI({ type: 'SET_SHOW_FILTER_MODAL', payload: false });
  };

  const toggleFilterModal = () => {
    dispatchUI({ type: 'SET_SHOW_CONFIRMATION_MODAL', payload: false });
    dispatchUI({ type: 'TOGGLE_FILTER_MODAL' });
  };


  useEffect(() => {
    // Check if values have actually changed
    const teamsString = JSON.stringify(teams);
    const invStatusListString = JSON.stringify(invStatusList);
    const invPaymStatusListString = JSON.stringify(invPaymStatusList);
    const currentKey = `${teamsString}-${invStatusListString}-${invPaymStatusListString}-${reimbursementInvoiceType}`;
    const prevKey = prevTeamsRef.current;

    if (prevKey !== currentKey && teams.length > 0 && invStatusList.length > 0 && invPaymStatusList.length > 0) {
      prevTeamsRef.current = currentKey;
      setSelectedTeams(teams.map((team) => team._id));
      setSelectedStatus(invStatusList.map((status) => status._id));
      setSelectedPaymentStatus(invPaymStatusList.map((paymentstatus) => paymentstatus._id));
      setSelectedInvTypes(
        reimbursementInvoiceType === "Reimbursement"
          ? ["Reimbursement"]
          : ["Regular", "Reimbursement"]
      );
    } else if (prevKey === null && teams.length > 0 && invStatusList.length > 0 && invPaymStatusList.length > 0) {
      // First run
      prevTeamsRef.current = currentKey;
      setSelectedTeams(teams.map((team) => team._id));
      setSelectedStatus(invStatusList.map((status) => status._id));
      setSelectedPaymentStatus(invPaymStatusList.map((paymentstatus) => paymentstatus._id));
      setSelectedInvTypes(
        reimbursementInvoiceType === "Reimbursement"
          ? ["Reimbursement"]
          : ["Regular", "Reimbursement"]
      );
    }
  }, [teams, invStatusList, invPaymStatusList, reimbursementInvoiceType]);

  // Note: fetchPaymentDetails function was removed as it was declared but never called
  // Memoized component to prevent unnecessary re-renders when parent updates
  const RenderMemberName = React.memo(({ rowData }) => {
    const [showFullname, setShowFullname] = React.useState(false);
    const fullName = rowData?.first_name
      ? `${rowData.first_name} ${rowData.middle_name && rowData.middle_name !== "null"
        ? rowData.middle_name + " "
        : ""
      }${rowData.last_name}`
      : rowData?.company_first_name
        ? `${rowData.company_first_name} ${rowData.company_last_name ? rowData.company_last_name : ""
        }`
        : rowData?.company_name;

    const displayName = showFullname
      ? fullName
      : fullName?.length <= 15
        ? fullName
        : fullName?.slice(0, 15) + "...";

    return (
      <div
        className={`member-name${showFullname ? " active" : ""}`}
        onMouseEnter={() => {
          if (fullName?.length > 15) {
            setShowFullname(true);
          }
        }}
        onMouseLeave={() => setShowFullname(false)}
      >
        <MemberAvatar
          src={rowData?.profile_image && rowData.profile_image !== "null" && rowData.profile_image !== "undefined" ? `/uploads/lowProfileImage/${rowData.profile_image}` : DEFAULT_AVATAR}
          alt={fullName}
        />
        <span>{displayName}</span>
      </div>
    );
  }, (prevProps, nextProps) => {
    // Custom comparison function for better performance
    // Only re-render if rowData actually changed
    if (!prevProps.rowData || !nextProps.rowData) {
      return prevProps.rowData === nextProps.rowData;
    }

    // Compare relevant fields that affect rendering
    return (
      prevProps.rowData._id === nextProps.rowData._id &&
      prevProps.rowData.first_name === nextProps.rowData.first_name &&
      prevProps.rowData.middle_name === nextProps.rowData.middle_name &&
      prevProps.rowData.last_name === nextProps.rowData.last_name &&
      prevProps.rowData.company_first_name === nextProps.rowData.company_first_name &&
      prevProps.rowData.company_last_name === nextProps.rowData.company_last_name &&
      prevProps.rowData.company_name === nextProps.rowData.company_name &&
      prevProps.rowData.profile_image === nextProps.rowData.profile_image
    );
  });

  const renderStatus = (rowData) => {
    // Determine the class based on the payment_status value
    let statusClass;
    let statusName;
    if (rowData.inv_status === invStatusConsts.Approved) {
      statusClass = "manual";
      statusName = "Approved";
    } else if (rowData.inv_status === invStatusConsts.Not_Reviewed) {
      statusClass = "pending";
      statusName = "Not Reviewed";
    } else if (rowData.inv_status === invStatusConsts.Rejected) {
      statusClass = "overdue";
      statusName = "Rejected";
    } else if (rowData.inv_payment_status === invStatusConsts.Cancelled) {
      statusClass = "overdue";
      statusName = "Cancelled";
    }
    return (
      <span className={`payment-status ${statusClass}`}>{statusName}</span>
    );
  };

  const handleAutomaticModalOpen = () => {
    setInvoiceTypeModalIsOpen(true);
  };

  const handleModalCancel = () => {
    setInvoiceTypeModalIsOpen(false);
    setIsTypeExiting(false);
    setTimeout(() => {
      setUserSelectModal(false);
    }, 300);
  };

  const handleInvoiceTypeSelect = (isAutomatic) => {
    setIsAutomaticInv(isAutomatic);
    setIsTypeExiting(true);
    setTimeout(() => {
      setUserSelectModal(true);
      setIsTypeExiting(false);
    }, 220);
  };

  const exportToExcel = async () => {
    setIsExportLoading(true);
    try {
      const response = await axios.post(
        "/api/invoices-optimized",
        {
          startDate: dateRange ? dateRange[0] : null,
          endDate: dateRange ? dateRange[1] : null,
          invNumber: invNumFilter || "",
          invTypes: invTypeFilter,
          invCreatedDates: Array.isArray(dateRange) && dateRange.length === 2
            ? [new Date(dateRange[0]).toISOString(), new Date(dateRange[1]).toISOString()]
            : null,
          invDueDates: selectedDate ? [selectedDate.toISOString()] : null,
          invStatuses: statusFilter,
          invPaymentStatuses: paymentStatusFilter,
          userIds: userFilter,
          tz,
          page: 1,
          limit: invoiceTotal,
          sortByUserName: null,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const invoices = response.data.invoices;
      if (invoices.length === 0) {
        toast.error("No data to export.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }
      //  const now = new Date();
      const now = moment.tz(new Date(), global.config.getTimeZone()).toDate();
      const formattedDate =
        now.getFullYear() +
        "-" +
        (now.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        now.getDate().toString().padStart(2, "0");
      const formattedTime =
        now.getHours().toString().padStart(2, "0") +
        ":" +
        now.getMinutes().toString().padStart(2, "0") +
        ":" +
        now.getSeconds().toString().padStart(2, "0");

      const paymentDetailsPromises = invoices.map(async (item) => {
        if (item.inv_number && (item.inv_payment_status === 2 || item.inv_payment_status === 3)) {
          try {
            const response = await fetch('/api/invoices/paymentDetails', {
              method: 'POST',
              body: JSON.stringify({ _id: item._id }),
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            });
            if (response.ok) {
              const data = await response.json();
              return data;
            } else {
              return null;
            }
          } catch (error) {
            // Non-blocking error handling for payment details
            Promise.resolve().then(() => {
              handleInvoiceError(error, "fetching payment details", { showToast: false });
            });
            return null;
          }
        } else {
          return null;
        }
      });

      const paymentDetails = await Promise.all(paymentDetailsPromises);

      const modifiedLog = [];
      invoices.forEach((item, index) => {

        const descriptions = item.inv_description;
        const costs = item.inv_cost;
        const taxs = item.inv_tax;
        const paymentData = paymentDetails[index];
        const paymentDate = paymentData ? paymentData.created_at : null;

        let statusName;
        if (!paymentDate) {
          statusName = 'Not updated';
        } else {
          statusName = moment(paymentDate).tz(global.config.getTimeZone()).format("DD/MM/YYYY, hh:mm:ss A");
        }

        if (descriptions && descriptions.length > 0) {
          descriptions.forEach((description, i) => {
            const cost = parseFloat(costs[i]);
            const tax = parseFloat(taxs[i]);
            const vat = (cost * (tax / 100)).toFixed(2);
            const amount = (cost + parseFloat(vat)).toFixed(2);
            modifiedLog.push({
              "Invoice Number": item.inv_number,
              "Invoice Type": item.inv_type,
              "Invoice Issue Date": moment.tz(item.inv_issue_date, global.config.getTimeZone()).format("DD/MM/YYYY"),
              "Invoice Due Date": moment.tz(item.inv_due_date, global.config.getTimeZone()).format("DD/MM/YYYY"),
              Period:
                moment.tz(item.inv_start_date || item.inv_strat_date, global.config.getTimeZone()).format("DD/MM/YYYY") +
                " - " +
                moment.tz(item.inv_end_date, global.config.getTimeZone()).format("DD/MM/YYYY"),
              User: item.inv_for
                ? item.inv_for.first_name
                  ? `${item.inv_for.first_name} ${item.inv_for.middle_name ? item.inv_for.middle_name : ""
                  } ${item.inv_for.last_name ? item.inv_for.last_name : ""}`
                  : item.inv_for.company_first_name
                    ? `${item.inv_for.company_first_name} ${item.inv_for.company_last_name
                      ? item.inv_for.company_last_name
                      : ""
                    }`
                    : item.inv_for.company_name
                : "",
              Item: i + 1,
              Description: description,
              Cost: costs[i],
              "VAT(%)": taxs[i],
              VAT: (costs[i] * (taxs[i] / 100)).toFixed(2),
              Amount: amount,
              "Invoice Currency": item.inv_currency,
              "Invoice Payment Date & Time": statusName,
              "Created At": moment.tz(item.inv_created_at, global.config.getTimeZone()).format("DD/MM/YYYY, hh:mm:ss A"),
            });
          });
        } else {
          modifiedLog.push({
            "Invoice Number": item.inv_number,
            "Invoice Type": item.inv_type,
            "Invoice Issue Date": moment.tz(item.inv_issue_date, global.config.getTimeZone()).format("DD/MM/YYYY"),
            "Invoice Due Date": moment.tz(item.inv_due_date, global.config.getTimeZone()).format("DD/MM/YYYY"),
            // .tz(global.config.getTimeZone())

            Period:
              moment.tz(item.inv_start_date || item.inv_strat_date, global.config.getTimeZone()).format("DD/MM/YYYY") +
              " - " +
              moment.tz(item.inv_end_date, global.config.getTimeZone()).format("DD/MM/YYYY"),
            User: item.inv_for
              ? item.inv_for.first_name
                ? `${item.inv_for.first_name}${item.inv_for.middle_name && item.inv_for.middle_name !== "null" ? " " + item.inv_for.middle_name : ""} ${item.inv_for.last_name ?? ""}`
                : item.inv_for.company_first_name
                  ? `${item.inv_for.company_first_name}${item.inv_for.company_last_name ? " " + item.inv_for.company_last_name : ""}`
                  : item.inv_for.company_name ?? ""
              : "",
            Item: 1,
            Description: "",
            Cost: "",
            "VAT(%)": "",
            Amount: "",
            "Invoice Currency": item.inv_currency,
            "Invoice Payment Date & Time": statusName,
            Company: item.inv_for
              ? item.inv_for.user_wx_comapny?.wx_company ?? ""
              : "",
            "Payment Bank": item.inv_for
              ? item.inv_for.user_wx_comapny?.country ?? ""
              : "",
            "Created At": moment.tz(item.inv_created_at, global.config.getTimeZone()).format("DD/MM/YYYY, hh:mm:ss A"),
          });
        }
      });

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(modifiedLog);
      const colWidths = [
        { wpx: 80 },
        { wpx: 80 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 125 },
        { wpx: 125 },
        { wpx: 35 },
        { wpx: 200 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 175 },
        { wpx: 125 },
        { wpx: 100 },
        { wpx: 150 },
      ];
      worksheet["!cols"] = colWidths;

      // Add alignment to center align the first row and increase font size
      const firstRow = XLSX.utils.decode_range(worksheet["!ref"]).s.r;
      for (let i = 0; i < colWidths.length; i++) {
        const cell = XLSX.utils.encode_cell({ r: firstRow, c: i });
        const style = worksheet[cell]?.s || {};
        style.alignment = style.alignment || {};
        style.alignment.horizontal = "center !important";
        style.alignment.vertical = "center !important";
        style.font = { size: 14, bold: true };
        worksheet[cell] = { ...worksheet[cell], s: style };
      }

      // Set border for active area and increase font size
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cell = XLSX.utils.encode_cell({ r: row, c: col });
          const style = worksheet[cell]?.s || {};
          style.font = { size: 12 };
          worksheet[cell] = { ...worksheet[cell], s: style };
        }
      }
      global.config.activityLog(
        window.location.href,
        "Invoice",
        "Invoices List exported to Excel"
      );
      const fileName = `Invoice_Report_${formattedDate}_${formattedTime}.xlsx`;
      worksheet["!autofilter"] = { ref: range };
      XLSX.utils.book_append_sheet(workbook, worksheet, "Invoice Report");
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      global.config.activityLog(
        window.location.href,
        "Invoice",
        "Error occurred while exporting INVOICES to Excel"
      );
      handleExportError(error, "exporting to Excel");
    } finally {
      setIsExportLoading(false);
    }
  };

  const downloadSelectedPDF = async () => {
    if (selectedRows.length === 0) {
      toast.error("Please select at least one invoice to download.", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    if (selectedRows.length > 10) {
      toast.error("Please select only Maximum of 10 invoices!", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setSelectAll(false);
      setSelectedRows([]);
      return;
    }

    try {

      setIsLoadingDownload(true);
      // Download each PDF file separately
      const zip = new JSZip();
      const folder = zip.folder("invoices"); // Optional: create a folder inside ZIP

      for (const row of selectedRows) {
        const formattedDate = new Date().toISOString().replace(/[-:]/g, "_");
        const filename = `invoices_${row.inv_number}_${formattedDate}.pdf`;

        // Step 1: Create the invoice
        await axios.post(
          `/api/invoice/create-multiple`,
          { invoiceId: row._id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Step 2: Download the generated PDF
        const pdfBlobResponse = await axios.get(
          `/api/invoice/download/created-multiple/pdf/${row._id}`,
          {
            responseType: "blob",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Step 3: Add PDF Blob to ZIP file
        folder.file(filename, pdfBlobResponse.data, { binary: true });
      }

      // Step 4: Generate ZIP and trigger download
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `invoices_${new Date().toISOString().replace(/[-:]/g, "_")}.zip`);

      // Step 5: Reset UI state and show success message
      setSelectAll(false);
      setSelectedRows([]);
      toast.success("All the Selected Invoices are Downloaded Successfully!", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      global.config.activityLog(
        window.location.href,
        "Invoice",
        "All the Selected Invoices are Downloaded Successfully"
      );
    } catch (error) {
      global.config.activityLog(
        window.location.href,
        "Invoice",
        "Something went wrong while creating or downloading the PDFs in bulk."
      );

      if (error.response?.data?.status === "deleted") {
        handleUserDeletionError(handleUserDeletion);
        return;
      }

      handleDownloadError(error, "creating or downloading PDFs");
    } finally {
      setIsLoadingDownload(false);
    }
  };

  const handleRowsPerPageChange = (e) => {
    const selected = [...selectedRows];
    const newRowsPerPage = parseInt(e.target.value);
    setRowsPerPage(newRowsPerPage);
    if (selected.length === newRowsPerPage) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
    setCurrentPage(1); // Set the current page to 0 when changing rows per page
  };

  const totalPages = Math.ceil(total / rowsPerPage);

  const onPageChange = (pageNumber) => {
    setSelectAllByPage((prevSelectAllByPage) => ({
      ...prevSelectAllByPage,
      [currentPage]: selectAll,
    }));
    setCurrentPage(pageNumber);
    setSelectAll(selectAllByPage[pageNumber] || false);
  };

  const checkboxTemplate = (rowData, rowIndex) => {
    return (
      <input
        type="checkbox"
        onChange={(e) => handleCheckboxChange(e, rowData, rowIndex)}
        checked={isSelected(rowData)}
      />
    );
  };

  const handleSelectAllChange = () => {
    const selected = [...selectedRows];
    const startIdx = 0;
    const endIdx = products.length;
    const rowsOnPage = products.slice(startIdx, endIdx);

    if (!selectAll) {
      const newRowsToAdd = rowsOnPage.filter(
        (row) => !selected.some((selectedRow) => isEqual(selectedRow, row))
      );
      if (selected.length + newRowsToAdd.length > 10) {
        toast.error("Please select only a maximum of 10 invoices!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }

      // Add the rows on the current page to the selected rows
      const newSelectedRows = [
        ...selected,
        ...rowsOnPage.filter(
          (row) => !selected.some((selectedRow) => isEqual(selectedRow, row))
        ),
      ];
      setSelectedRows(newSelectedRows);
    } else {
      // Deselect the rows on the current page
      const remaining = selected.filter(
        (row) => !rowsOnPage.some((pageRow) => isEqual(row, pageRow))
      );
      setSelectedRows(remaining);
    }

    setSelectAll(!selectAll);
  };

  const handleCheckboxChange = (e, rowData, rowIndex) => {
    const selected = [...selectedRows];
    const index = selected.findIndex((item) => isEqual(item, rowData));

    if (e.nativeEvent.shiftKey && lastSelectedRowIndex !== null) {
      const startIdx = Math.min(lastSelectedRowIndex, rowIndex);
      const endIdx = Math.max(lastSelectedRowIndex, rowIndex);

      for (let i = startIdx; i <= endIdx; i++) {
        const currentRowData = products[i];
        const currentIndex = selected.findIndex((item) =>
          isEqual(item, currentRowData)
        );

        if (e.target.checked) {
          if (selected.length >= 10) {
            toast.error("Please select only a maximum of 10 invoices!", {
              position: "bottom-right",
              autoClose: 1500,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            return;
          }
          if (currentIndex === -1) {
            selected.push(currentRowData);
          }
        } else if (currentIndex !== -1) {
          selected.splice(currentIndex, 1);
        }
      }
    } else {
      // Handle single row selection
      if (e.target.checked) {
        if (selected.length >= 10) {
          toast.error("Please select only a maximum of 10 invoices!", {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }
        selected.push(rowData);
      } else if (index !== -1) {
        selected.splice(index, 1);
      }
    }

    setLastSelectedRowIndex(rowIndex);

    // Check if all checkboxes on the current page are selected
    const startIdx = 0;
    const endIdx = products.length;
    const rowsOnPage = products.slice(startIdx, endIdx);
    const allSelectedOnPage = rowsOnPage.every((row) =>
      selected.some((item) => isEqual(item, row))
    );

    setSelectAll(allSelectedOnPage);
    setSelectedRows(selected);
  };

  const isSelected = (rowData) => {
    return selectedRows.some((item) => isEqual(item, rowData));
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDir((prev) => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortField(field);
      setSortDir('asc');
    }
    setCurrentPage(1);
  };

  const SortIcon = ({ field }) => {
    const active = sortField === field;
    const upActive = active && sortDir === 'asc';
    const downActive = active && sortDir === 'desc';
    return (
      <span className="sort-icon-wrap" style={{ display: "inline-flex", flexDirection: "column", gap: "2px", marginLeft: "6px", verticalAlign: "middle", flexShrink: 0 }}>
        <svg data-active={upActive ? "true" : "false"} width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: "block", transition: "opacity 0.15s ease, color 0.15s ease", opacity: upActive ? 1 : active ? 0.2 : 0.4, color: "#405BFF" }}>
          <path d="M1 4L4 1L7 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <svg data-active={downActive ? "true" : "false"} width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: "block", transition: "opacity 0.15s ease, color 0.15s ease", opacity: downActive ? 1 : active ? 0.2 : 0.4, color: "#405BFF" }}>
          <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    );
  };

  const componentRef = useRef(null);
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };

  return (
    <motion.div
      ref={componentRef}
      initial="hidden"
      animate="visible"
      variants={fadeIn}
      transition={{ duration: 0.3 }}
    >
      <div className="invoice-outer-invoice">
        <div className="invoice-top">
          {isMobile && <h2 className="mobile-invoices-page-title">Invoices</h2>}
          <div className="new-top-flter">
            <div className="button-sec-invoice">
              <a onClick={handleAutomaticModalOpen}>
                <span className="icon-invoice">
                  <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.1196 1H1.3806C1.17042 1 1 1.17015 1 1.38V19.62C1 19.7208 1.0401 19.8175 1.11146 19.8887C1.18282 19.96 1.27967 20 1.3806 20H16.1196C16.2205 20 16.3173 19.96 16.3887 19.8887C16.4601 19.8175 16.5002 19.7208 16.5002 19.62V1.38C16.5002 1.27923 16.4601 1.18253 16.3887 1.11129C16.3173 1.04004 16.2205 1 16.1196 1ZM15.739 19.24H1.76119V1.76H15.739V19.24Z" fill="white" stroke="white" strokeWidth="0.6" /><path d="M4.49323 4.97015H13.007C13.2134 4.97015 13.3808 4.77968 13.3808 4.54477C13.3808 4.30987 13.2134 4.1194 13.007 4.1194H4.49323C4.2868 4.1194 4.11942 4.30987 4.11942 4.54477C4.11942 4.77968 4.2868 4.97015 4.49323 4.97015Z" fill="white" stroke="white" strokeWidth="0.6" /><path d="M4.49323 7.80596H13.007C13.2134 7.80596 13.3808 7.61549 13.3808 7.38059C13.3808 7.14569 13.2134 6.95522 13.007 6.95522H4.49323C4.2868 6.95522 4.11942 7.14569 4.11942 7.38059C4.11942 7.61549 4.2868 7.80596 4.49323 7.80596Z" fill="white" stroke="white" strokeWidth="0.6" /><path d="M4.49323 10.6418H13.007C13.2134 10.6418 13.3808 10.4513 13.3808 10.2164C13.3808 9.9815 13.2134 9.79103 13.007 9.79103H4.49323C4.2868 9.79103 4.11942 9.9815 4.11942 10.2164C4.11942 10.4513 4.2868 10.6418 4.49323 10.6418Z" fill="white" stroke="white" strokeWidth="0.6" /><path d="M8.39066 16.3134H13.007C13.2134 16.3134 13.3808 16.123 13.3808 15.8881C13.3808 15.6531 13.2134 15.4627 13.007 15.4627H8.39066C8.18423 15.4627 8.01685 15.6531 8.01685 15.8881C8.01685 16.123 8.18423 16.3134 8.39066 16.3134Z" fill="white" stroke="white" strokeWidth="0.6" /></svg>
                </span>
                Create Invoice
              </a>
              {/* invoice modal — single modal, content swaps to avoid overlay blink */}
              <Modal
                isOpen={invoiceTypeModalIsOpen}
                onRequestClose={handleModalCancel}
                className="new-item-modal"
                overlayClassName={isMobileSheet ? "mobile-sheet-overlay" : undefined}
                contentLabel="Invoice"
                closeTimeoutMS={480}
              >
                <div className="modal">
                  {isMobileSheet ? (
                    <div className="mobile-bottom-sheet-header">
                      <button type="button" className="mobile-sheet-close-circle" onClick={handleModalCancel}>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L11 11M1 11L11 1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                      <h3 className="mobile-sheet-title">Create Invoice</h3>
                    </div>
                  ) : (
                    <div className="outter-modal-main">
                      <a
                        className="close-image-clr1"
                        onClick={handleModalCancel}
                      >
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.41895 12L11.9189 1.5" stroke="#FE6161" strokeWidth="1.5" /><path d="M1.41895 1.5L11.9189 12" stroke="#FE6161" strokeWidth="1.5" /></svg>{" "}
                      </a>
                    </div>
                  )}
                  <div
                    key={userSelectModal ? "form" : "type"}
                    className={`invoice-modal-view${isTypeExiting ? " modal-view-exit" : ""}`}
                  >
                    {userSelectModal ? (
                      <InvoiceModal isAutomaticInv={isAutomaticInv} />
                    ) : isMobileSheet ? (
                      <div className="mobile-inv-type-selector-wrap">
                        <p className="mobile-inv-type-subtitle">Select the type of invoice:</p>
                        <div className="mobile-inv-type-list">
                          <div
                            className="mobile-inv-type-row"
                            onClick={() => handleInvoiceTypeSelect(false)}
                          >
                            <span className="mobile-inv-type-text">Manual Invoice</span>
                            <ItemIcon />
                          </div>
                          <div
                            className="mobile-inv-type-row"
                            onClick={() => handleInvoiceTypeSelect(true)}
                          >
                            <span className="mobile-inv-type-text">Automatic invoice</span>
                            <ItemIcon />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="outter-modal-main-2">
                        <p>Type of Invoice</p>
                        <div className="modal-btn-main">
                          <button onClick={() => handleInvoiceTypeSelect(false)}>
                            Manually
                          </button>
                          <button onClick={() => handleInvoiceTypeSelect(true)}>
                            Automatic
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Modal>
              {/* invoice modal end */}
              {!isMvpMobile && (
                <a
                  onClick={(isExportLoading || teamLoading) ? undefined : exportToExcel}
                  disabled={isExportLoading}
                  style={{
                    minWidth: "120px",
                    pointerEvents: (isExportLoading || teamLoading) ? "none" : "auto",
                    cursor: (isExportLoading || teamLoading) ? "default" : "pointer",
                    opacity: (isExportLoading || teamLoading) ? 0.7 : 1,
                  }}
                >
                  <>
                    <span className="icon-invoice">
                      {isExportLoading ? <span className="btn-spinner" /> : <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.52625 15.8539C6.55157 15.8771 6.57923 15.8979 6.60884 15.9161L6.65014 15.9361L6.70235 15.9621L6.75689 15.9782L6.80482 15.9904C6.87651 16.0043 6.95092 16.0043 7.023 15.9904L7.07092 15.9782L7.12547 15.9621L7.17767 15.9361L7.21897 15.9161C7.24897 15.8979 7.27664 15.8771 7.30196 15.8539L12.6977 10.9C12.8773 10.7014 12.8625 10.41 12.6634 10.2275C12.4643 10.045 12.1464 10.0314 11.9298 10.1961L7.45702 14.3V1.5C7.45702 1.22393 7.21274 1 6.91157 1C6.6104 1 6.36612 1.22393 6.36612 1.5V14.3L1.89339 10.1961C1.67677 10.0314 1.35884 10.045 1.15975 10.2275C0.960661 10.41 0.945856 10.7014 1.12547 10.9L6.52547 15.8539H6.52625Z" fill="white" stroke="white" strokeWidth="0.5" /></svg>}
                    </span>
                    Export Data
                  </>
                </a>
              )}

              {!isMvpMobile && user &&
                (user.userType === userTypeConsts.SUPER_ADMIN ||
                  user.userType === userTypeConsts.ADMIN) && (
                  <>
                    <a
                      onClick={isLoadingDownload ? undefined : downloadSelectedPDF}
                      disabled={isLoadingDownload}
                      style={{
                        pointerEvents: isLoadingDownload ? "none" : "auto",
                        cursor: isLoadingDownload ? "default" : "pointer",
                        opacity: isLoadingDownload ? 0.7 : 1,
                      }}
                    >
                      <>
                        <span className="icon-invoice">
                          {isLoadingDownload ? <span className="btn-spinner" /> : <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.52625 15.8539C6.55157 15.8771 6.57923 15.8979 6.60884 15.9161L6.65014 15.9361L6.70235 15.9621L6.75689 15.9782L6.80482 15.9904C6.87651 16.0043 6.95092 16.0043 7.023 15.9904L7.07092 15.9782L7.12547 15.9621L7.17767 15.9361L7.21897 15.9161C7.24897 15.8979 7.27664 15.8771 7.30196 15.8539L12.6977 10.9C12.8773 10.7014 12.8625 10.41 12.6634 10.2275C12.4643 10.045 12.1464 10.0314 11.9298 10.1961L7.45702 14.3V1.5C7.45702 1.22393 7.21274 1 6.91157 1C6.6104 1 6.36612 1.22393 6.36612 1.5V14.3L1.89339 10.1961C1.67677 10.0314 1.35884 10.045 1.15975 10.2275C0.960661 10.41 0.945856 10.7014 1.12547 10.9L6.52547 15.8539H6.52625Z" fill="white" stroke="white" strokeWidth="0.5" /></svg>}
                        </span>
                        Download
                      </>
                    </a>
                  </>
                )}
            </div>
            {!isMvpMobile && (
              <div className="filter-invoice-right">
                <div className="filter-inner showing-result">
                  <label>Showing</label>
                  <div
                    ref={showingDropdownRef}
                    className="select-modal-mainM custom-dropdown-user-new-outer"
                  >
                    <div
                      className="selected-option custom-dropdown-user-new"
                      onClick={() => setShowingDropdownOpen(!showingDropdownOpen)}
                    >
                      {total < 10 ? total.toString() : rowsPerPage.toString()}
                    </div>
                    {showingDropdownOpen && (
                      <div className="custom-dropdown-new">
                        <ul className="showing-options-list">
                          {total >= 10 && (
                            <li
                              className={rowsPerPage === 10 ? "selected-item" : ""}
                              onClick={() => {
                                handleRowsPerPageChange({ target: { value: 10 } });
                                setShowingDropdownOpen(false);
                              }}
                            >
                              10
                            </li>
                          )}
                          {total >= 20 && (
                            <li
                              className={rowsPerPage === 20 ? "selected-item" : ""}
                              onClick={() => {
                                handleRowsPerPageChange({ target: { value: 20 } });
                                setShowingDropdownOpen(false);
                              }}
                            >
                              20
                            </li>
                          )}
                          {total >= 30 && (
                            <li
                              className={rowsPerPage === 30 ? "selected-item" : ""}
                              onClick={() => {
                                handleRowsPerPageChange({ target: { value: 30 } });
                                setShowingDropdownOpen(false);
                              }}
                            >
                              30
                            </li>
                          )}
                          {total >= 40 && (
                            <li
                              className={rowsPerPage === 40 ? "selected-item" : ""}
                              onClick={() => {
                                handleRowsPerPageChange({ target: { value: 40 } });
                                setShowingDropdownOpen(false);
                              }}
                            >
                              40
                            </li>
                          )}
                          {total > 10 && (
                            <li
                              className={
                                total > 10 && rowsPerPage === total
                                  ? "selected-item"
                                  : ""
                              }
                              onClick={() => {
                                handleRowsPerPageChange({
                                  target: { value: total },
                                });
                                setShowingDropdownOpen(false);
                              }}
                            >
                              ALL
                            </li>
                          )}
                          {total < 10 ? (
                            <li
                              className={total < 10 ? "selected-item" : ""}
                              onClick={() => {
                                handleRowsPerPageChange({
                                  target: { value: total },
                                });
                                setShowingDropdownOpen(false);
                              }}
                            >
                              {total}
                            </li>
                          ) : null}
                        </ul>
                      </div>
                    )}
                  </div>
                  <label>of {total} Results</label>
                </div>
              </div>
            )}
          </div>

          <div className="invoice-filter">
            <div className="invoice-filter-inner-section no-flter-all">
              <div className="filter-inner invoice-id">
                <label htmlFor="fname">Invoice ID</label>
                <input
                  type="text"
                  onChange={(e) => {
                    setInvoiceNumberFilter(e.target.value);
                    setDebouncedValue(e.target.value);
                    setCurrentPage(1);
                  }}
                  value={invoiceNumberFilter}
                  id="invoiceId"
                  name="invoiceId"
                  placeholder="All"
                />
              </div>
              {user &&
                (user.userType === userTypeConsts.SUPER_ADMIN ||
                  user.userType === userTypeConsts.ADMIN) && (
                  <div className="filter-inner invoice-status">
                    <label htmlFor="user">User</label>
                    <div className="custom-dropdown1" ref={teamDropdownRef}>
                      <div className="drop-down-inner">
                        <div
                          className="selected-options1"
                          onClick={toggleTeamDropdown}
                        >
                          {selectedTeams.length === 0 ? (
                            <div className="placeholder">All</div>
                          ) : (
                            <>
                              <div
                                className="selected-option1"
                                key={selectedTeams[0]}
                              >
                                {selectedTeams.length === teams.length ? (
                                  `All`
                                ) : (
                                  <>
                                    <TruncateFilterFieldView
                                      textContent={
                                        teams.find(
                                          (item) => item._id === selectedTeams[0]
                                        )?.first_name
                                          ? `${teams.find((item) => item._id === selectedTeams[0]).first_name
                                          } ${teams.find((item) => item._id === selectedTeams[0]).middle_name
                                            ? teams.find((item) => item._id === selectedTeams[0]).middle_name
                                            : ""
                                          } ${teams.find((item) => item._id === selectedTeams[0]).last_name
                                            ? teams.find((item) => item._id === selectedTeams[0]).last_name
                                            : ""
                                          }`
                                          : teams.find((item) => item._id === selectedTeams[0]).company_first_name
                                            ? `${teams.find((item) => item._id === selectedTeams[0]).company_first_name} 
                                              ${teams.find((item) => item._id === selectedTeams[0]).company_last_name
                                              ? teams.find((item) => item._id === selectedTeams[0]).company_last_name
                                              : ""
                                            }`
                                            : `${teams.find((item) => item._id === selectedTeams[0]).company_name} (Company)`
                                      }
                                    />
                                    {selectedTeams.length > 1 &&
                                      selectedTeams.length !== teams.length && (
                                        <div className="selected-option-count">
                                          {selectedTeams.length - 1}+
                                        </div>
                                      )}
                                  </>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                        {isTeamDropdownOpen && (
                          <div className="dropdown-list1">
                            <input
                              type="text"
                              placeholder="Search teams"
                              value={userSearchTerm}
                              onChange={handleUserSearchChange}
                              className="search-bar"
                              disabled={teamLoading}
                              style={{
                                pointerEvents: teamLoading ? "none" : "auto",
                                opacity: teamLoading ? 0.6 : 1,
                              }}
                            />
                            {teamLoading ? (
                              <>
                                {Array.from({ length: 5 }).map((_, index) => (
                                  <label
                                    key={`skeleton-team-${index}`}
                                    className="checkbox-label1"
                                    style={{
                                      pointerEvents: "none",
                                      cursor: "default",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        backgroundColor: "#e5e7eb",
                                        borderRadius: "3px",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                        flexShrink: 0,
                                      }}
                                    />
                                    <div
                                      style={{
                                        width: "150px",
                                        height: "16px",
                                        backgroundColor: "#e5e7eb",
                                        borderRadius: "4px",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                      }}
                                    />
                                  </label>
                                ))}
                              </>
                            ) : (
                              <>
                                {filteredUsers.length > 0 && (
                                  <>
                                    {userSearchTerm === "" && (
                                      <label className="checkbox-label1" key="selectAll" >
                                        <input
                                          type="checkbox"
                                          checked={selectAllTeam}
                                          onChange={handleSelectAllTeamChange}
                                        />
                                        All Teams
                                      </label>
                                    )}
                                    {filteredUsers.map((team) => (
                                      <label
                                        className="checkbox-label1"
                                        key={team._id}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={selectedTeams.includes(team._id)}
                                          onChange={() =>
                                            handleCheckboxTeamChange(team._id)
                                          }
                                        />
                                        {team.first_name
                                          ? `${team.first_name} ${team.middle_name ? team.middle_name : ""
                                          } ${team.last_name}`
                                          : team.company_first_name
                                            ? `${team.company_first_name} ${team.company_last_name
                                              ? team.company_last_name
                                              : ""
                                            }`
                                            : `${team.company_name} (Company)`}
                                      </label>
                                    ))}
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              <div className="filter-inner invoice-status">
                <label htmlFor="invoiceStatus">Invoice Status</label>
                <div className="custom-dropdown1" ref={statusDropdownRef}>
                  <div className="drop-down-inner">
                    <div
                      className="selected-options1"
                      onClick={toggleStatusDropdown}
                    >
                      {selectedStatus.length === 0 ? (
                        <div className="placeholder">All</div>
                      ) : (
                        <>
                          <div className="selected-option1" key={selectedStatus[0]} >
                            {selectedStatus.length === invStatusList.length ? (
                              "All"
                            ) : (
                              <>
                                <TruncateFilterFieldView
                                  textContent={
                                    invStatusList.find(
                                      (item) => item._id === selectedStatus[0]
                                    )?.status
                                  }
                                />
                                {selectedStatus.length > 1 &&
                                  selectedStatus.length !==
                                  invStatusList.length && (
                                    <div className="selected-option-count">
                                      {selectedStatus.length - 1}+
                                    </div>
                                  )}
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </div>

                    {isStatusDropdownOpen && (
                      <div className="dropdown-list1">
                        {invStatusList.length > 0 && (
                          <>
                            <label className="checkbox-label1" key="selectAll">
                              <input
                                type="checkbox"
                                checked={selectAllStatus}
                                onChange={handleSelectAllStatusChange}
                              />
                              All
                            </label>
                            {invStatusList.map((status) => (
                              <label className="checkbox-label1" key={status._id}>
                                <input
                                  type="checkbox"
                                  checked={selectedStatus.includes(status._id)}
                                  onChange={() =>
                                    handleCheckboxStatusChange(status._id)
                                  }
                                />
                                {status.status && `${status.status}`}
                              </label>
                            ))}
                          </>
                        )}
                      </div>
                    )}

                  </div>
                </div>
              </div>
              <div className="filter-inner payment-status">
                <label htmlFor="paymentStatus">Payment Status</label>
                <div className="custom-dropdown1" ref={paymentStatusDropdownRef}>
                  <div className="drop-down-inner">
                    <div
                      className="selected-options1"
                      onClick={togglePaymentStatusDropdown}
                    >
                      {selectedPaymentStatus.length === 0 ? (
                        <div className="placeholder">All</div>
                      ) : (
                        <div
                          className="selected-option1"
                          key={selectedPaymentStatus[0]}
                        >
                          {selectedPaymentStatus.length ===
                            invPaymStatusList.length ? (
                            "All"
                          ) : (
                            <>
                              <TruncateFilterFieldView
                                textContent={
                                  invPaymStatusList.find(
                                    (item) =>
                                      item._id === selectedPaymentStatus[0]
                                  )?.status
                                }
                              />
                              {selectedPaymentStatus.length > 1 &&
                                selectedPaymentStatus.length !==
                                invPaymStatusList.length && (
                                  <div className="selected-option-count">
                                    {selectedPaymentStatus.length - 1}+
                                  </div>
                                )}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                    {isPaymentStatusDropdownOpen && (
                      <div className="dropdown-list1">
                        <input
                          type="text"
                          placeholder="Search payment status"
                          value={paymentStatusSearchTerm}
                          onChange={handlePaymentStatusSearchChange}
                          className="search-bar"
                          disabled={invPaymStatusList.length === 0}
                          style={{
                            pointerEvents: invPaymStatusList.length === 0 ? "none" : "auto",
                            opacity: invPaymStatusList.length === 0 ? 0.6 : 1,
                          }}
                        />
                        {invPaymStatusList.length === 0 ? (
                          <>
                            {Array.from({ length: 5 }).map((_, index) => (
                              <label
                                key={`skeleton-payment-status-${index}`}
                                className="checkbox-label1"
                                style={{
                                  pointerEvents: "none",
                                  cursor: "default",
                                }}
                              >
                                <div
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "3px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                    flexShrink: 0,
                                  }}
                                />
                                <div
                                  style={{
                                    width: "120px",
                                    height: "16px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </label>
                            ))}
                          </>
                        ) : (
                          <>
                            {filteredInvPaymStatusList.length > 0 && (
                              <>
                                {paymentStatusSearchTerm === "" && (
                                  <label className="checkbox-label1" key="selectAll">
                                    <input
                                      type="checkbox"
                                      checked={selectAllPaymentStatus}
                                      onChange={handleSelectAllPaymentStatusChange}
                                    />
                                    All
                                  </label>
                                )}
                                {filteredInvPaymStatusList.map((paymentstatus) => (
                                  <label
                                    className="checkbox-label1"
                                    key={paymentstatus._id}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedPaymentStatus.includes(
                                        paymentstatus._id
                                      )}
                                      onChange={() =>
                                        handleCheckboxPaymentStatusChange(
                                          paymentstatus._id
                                        )
                                      }
                                    />
                                    {paymentstatus.status &&
                                      `${paymentstatus.status}`}
                                  </label>
                                ))}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="filter-inner due-date">
                <label htmlFor="dueDate" className="calendar-icon">
                  Due Date
                </label>
                <div className="date-picker-outer date-picker-outer-all">
                  <div className="custom-picker-icon custom-picker-icon-all">
                    <svg
                      width="1em"
                      height="1em"
                      viewBox="0 0 14 14"
                      fill="currentColor"
                      aria-hidden="true"
                      focusable="false"
                      className="rs-picker-toggle-caret rs-icon"
                      aria-label="calendar"
                      data-category="legacy"
                    >
                      <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                    </svg>
                  </div>
                  <div className="custoom-icon-calender custoom-icon-calender-all">
                    <DatePicker
                      oneTap
                      format="dd/MM/yyyy"
                      // ranges={ranges} // Set to current date
                      // value={selectedDate ? selectedDate : moment.tz(global?.config?.getTimeZone()).startOf("day").toDate()}
                      value={selectedDate}
                      onChange={handleDateChange}
                      placement="auto"
                      className="invoice-filter-top-date"
                      isoWeek={appSettings.weekStartDay && appSettings.weekStartDay === "Monday"}
                      renderValue={(date) => moment.tz(date, timeZone).format("DD/MM/YYYY")}
                    />
                  </div>
                </div>
              </div>
              <div className="filter-inner invoice-type">
                <label htmlFor="invoice-type">Invoice Type</label>
                <div className="custom-dropdown1" ref={invTypeDropdownRef}>
                  <div className="drop-down-inner">
                    <div
                      className="selected-options1"
                      onClick={toggleInvTypeDropdown}
                    >
                      {selectedInvTypes.length === 0 ? (
                        <div className="placeholder">All</div>
                      ) : (
                        <>
                          <div
                            className="selected-option1"
                            key={selectedInvTypes[0]}
                          >
                            {selectedInvTypes.length === 2
                              ? "All"
                              : selectedInvTypes.join(", ")}
                          </div>
                          {selectedInvTypes.length > 1 &&
                            selectedInvTypes.length !== 2 && (
                              <div className="selected-option-count">
                                {selectedInvTypes.length - 1}+
                              </div>
                            )}
                        </>
                      )}
                    </div>
                    {isInvTypeDropdownOpen && (
                      <div className="dropdown-list1">
                        <label className="checkbox-label1" key="selectAll">
                          <input
                            type="checkbox"
                            checked={selectAllInvType}
                            onChange={handleSelectAllInvTypeChange}
                          />
                          All Types
                        </label>
                        <label className="checkbox-label1" key="Regular">
                          <input
                            type="checkbox"
                            checked={selectedInvTypes.includes("Regular")}
                            onChange={() =>
                              handleCheckboxInvTypeChange("Regular")
                            }
                          />
                          Regular
                        </label>
                        <label
                          className="checkbox-label1"
                          key="Reimbursement"
                        >
                          <input
                            type="checkbox"
                            checked={selectedInvTypes.includes(
                              "Reimbursement"
                            )}
                            onChange={() =>
                              handleCheckboxInvTypeChange("Reimbursement")
                            }
                          />
                          Reimbursement
                        </label>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="filter-inner due-date">
                <label htmlFor="dueDate" className="calendar-icon">
                  Issue Date
                </label>
                <div
                  className="date-picker-outer date-picker-outer-all"
                  ref={calendarRef}
                >
                  <div className="custom-picker-icon custom-picker-icon-all">
                    <svg
                      width="1em"
                      height="1em"
                      viewBox="0 0 14 14"
                      fill="currentColor"
                      aria-hidden="true"
                      focusable="false"
                      className="rs-picker-toggle-caret rs-icon"
                      aria-label="calendar"
                      data-category="legacy"
                    >
                      <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                    </svg>
                  </div>
                  <div className="custoom-icon-calender custoom-icon-calender-all">
                    <div className="custoom-icon-calender custoom-icon-calender-all custom-date-range ">
                      <input
                        type="text"
                        value={

                          dateRange
                            ? `${moment.tz(dateRange[0], global.config.getTimeZone()).format("DD/MM/YYYY")} to ${moment.tz(dateRange[1], global.config.getTimeZone()).format("DD/MM/YYYY")}`
                            : ''
                        }
                        id="invoiceId"
                        name="invoiceId"
                        placeholder="All Time"
                        onClick={toggleCalendar}
                        autoComplete="off"
                        readOnly
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="date-range-new right-align">
                      {showCalendar && (
                        <Calendar
                          onCancel={cancelCalendar}
                          onChange={(range) => {
                            const adjustedStartDate = range.startDate ? new Date(range.startDate) : null;
                            const adjustedEndDate = range.endDate ? new Date(range.endDate) : null;
                            onDateChange({
                              startDate: adjustedStartDate,
                              endDate: adjustedEndDate,
                            });
                          }}
                          initialRange={{
                            startDate: dateRange ? moment.tz(dateRange[0], global.config.getTimeZone()).startOf("day").toDate() : null,
                            endDate: dateRange ? moment.tz(dateRange[1], global.config.getTimeZone()).startOf("day").toDate() : null,
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="filter-invoice-right apply-fliter-right">
              <button onClick={toggleFilterModal}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="17"
                  viewBox="0 0 13 17"
                  fill="none"
                >
                  <path
                    d="M11.7363 8.81108C11.4276 9.81451 10.4925 10.5444 9.38889 10.5444C8.28471 10.5444 7.35016 9.8141 7.04147 8.81108L0.722221 8.81108C0.323349 8.81108 -1.07845e-06 8.48773 -1.06101e-06 8.08886C-1.04357e-06 7.68998 0.323349 7.36663 0.722221 7.36663L7.04144 7.36663C7.35022 6.3632 8.28529 5.6333 9.38889 5.6333C10.4931 5.6333 11.4276 6.36362 11.7363 7.36663L12.2778 7.36663C12.6767 7.36663 13 7.68998 13 8.08886C13 8.48773 12.6766 8.81108 12.2778 8.81108L11.7363 8.81108ZM9.38889 7.07775C8.83162 7.07775 8.37778 7.53123 8.37778 8.08886C8.37778 8.64613 8.83127 9.09997 9.38889 9.09997C9.94616 9.09997 10.4 8.64648 10.4 8.08886C10.4 7.53158 9.94651 7.07775 9.38889 7.07775Z"
                    fill="#6479F8"
                  />
                  <path
                    d="M5.38078 3.17778C5.072 4.18121 4.13693 4.91111 3.03333 4.91111C1.92882 4.91111 0.994035 4.18035 0.68563 3.17687C0.303759 3.15781 -1.07791e-06 2.84216 -1.06101e-06 2.45556C-1.04411e-06 2.06896 0.303748 1.75331 0.685606 1.73425C0.994098 0.730343 1.9294 -4.83911e-07 3.03333 -4.35657e-07C4.13752 -3.87392e-07 5.07206 0.730315 5.38076 1.73333L12.2778 1.73333C12.6767 1.73333 13 2.05668 13 2.45556C13 2.85443 12.6766 3.17778 12.2778 3.17778L5.38078 3.17778ZM3.03333 1.44444C2.47606 1.44444 2.02222 1.89793 2.02222 2.45556C2.02222 3.01283 2.47571 3.46667 3.03333 3.46667C3.5906 3.46667 4.04444 3.01318 4.04444 2.45556C4.04444 1.89828 3.59096 1.44444 3.03333 1.44444Z"
                    fill="#6479F8"
                  />
                  <path
                    d="M7.403 14.4444C7.09422 15.4478 6.15916 16.1777 5.05556 16.1777C3.95137 16.1777 3.01682 15.4474 2.70813 14.4444L0.722221 14.4444C0.323349 14.4444 -1.07845e-06 14.121 -1.06101e-06 13.7222C-1.04357e-06 13.3233 0.323349 12.9999 0.722221 12.9999L2.70811 12.9999C3.01689 11.9965 3.95195 11.2666 5.05556 11.2666C6.15974 11.2666 7.09429 11.9969 7.40298 12.9999L12.2778 12.9999C12.6767 12.9999 13 13.3233 13 13.7222C13 14.121 12.6766 14.4444 12.2778 14.4444L7.403 14.4444ZM5.05556 12.711C4.49828 12.711 4.04444 13.1645 4.04444 13.7222C4.04444 14.2794 4.49793 14.7333 5.05556 14.7333C5.61283 14.7333 6.06667 14.2798 6.06667 13.7222C6.06667 13.1649 5.61318 12.711 5.05556 12.711Z"
                    fill="#6479F8"
                  />
                </svg>
                All Filters
              </button>
            </div>
            <Modal
              isOpen={showFilterModal}
              onRequestClose={checkAndShowConfirmationModal}
              contentLabel="Filter Modal"
              className={isMobileSheet ? "mobile-filters-bottom-sheet" : "new-filter-modal"}
              overlayClassName={isMobileSheet ? "mobile-filters-overlay" : "invoices-filter-overlay"}
              style={isMobileSheet ? {
                content: {
                  position: "fixed",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  top: "auto",
                  inset: "auto 0px 0px 0px",
                  width: "100%",
                  maxWidth: "100vw",
                  margin: 0,
                  padding: 0,
                  border: "none",
                  borderTopLeftRadius: "30px",
                  borderTopRightRadius: "30px",
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                  background: "#FFFFFF",
                  outline: "none",
                  maxHeight: "85vh",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  boxSizing: "border-box",
                },
                overlay: {
                  backgroundColor: "rgba(0, 0, 0, 0.45)",
                  zIndex: 99999,
                  position: "fixed",
                  inset: 0,
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                },
              } : {
                content: {
                  borderRadius: "10px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#fff",
                  padding: "20px",
                },
                overlay: {
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 99999,
                },
              }}
              closeTimeoutMS={480}
            >
              {isMobileSheet ? (
                /* ========================================================================= */
                /* MOBILE-ONLY FILTERS POPUP (Bottom Sheet Accordion - matching Users filter)*/
                /* ========================================================================= */
                <div className="mobile-filters-container">
                  {/* Header */}
                  <div className="mobile-filters-header">
                    <button
                      type="button"
                      className="mobile-filters-close-btn"
                      onClick={checkAndShowConfirmationModal}
                      aria-label="Close"
                    >
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.5 3.5L12.5 12.5M12.5 3.5L3.5 12.5" stroke="#1E293B" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <h3 className="mobile-filters-title">Filters</h3>
                    <button
                      type="button"
                      className="mobile-filters-apply-btn"
                      onClick={applyFilters}
                    >
                      Apply
                    </button>
                  </div>

                  {/* Accordion Filter Items */}
                  <div className="mobile-filters-body">
                    {/* 1. Invoice ID */}
                    <div className="mobile-filter-row">
                      <div
                        className="mobile-filter-row-header"
                        onClick={() => setOpenMobileAccordion(openMobileAccordion === 'invoiceId' ? null : 'invoiceId')}
                      >
                        <div className="mobile-filter-row-title-group">
                          <span className="mobile-filter-row-title">Invoice ID</span>
                          <span className="mobile-filter-row-value">
                            {invoiceNumberFilter ? `(${invoiceNumberFilter})` : '(All)'}
                          </span>
                        </div>
                        <ItemIcon className={`mobile-filter-chevron ${openMobileAccordion === 'invoiceId' ? 'expanded' : ''}`} />
                      </div>
                      <div className={`mobile-filter-accordion-wrapper ${openMobileAccordion === 'invoiceId' ? 'is-open' : ''}`}>
                        <div className="mobile-filter-accordion-inner">
                          <div className="mobile-filter-accordion-content">
                            <input
                              type="text"
                              className="mobile-filter-search-input"
                              placeholder="Search Invoice ID"
                              value={invoiceNumberFilter}
                              onChange={(e) => {
                                setInvoiceNumberFilter(e.target.value);
                                setDebouncedValue(e.target.value);
                                setCurrentPage(1);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 2. User Name (Super Admin / Admin) */}
                    {user && (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) && (
                      <div className="mobile-filter-row">
                        <div
                          className="mobile-filter-row-header"
                          onClick={() => setOpenMobileAccordion(openMobileAccordion === 'user' ? null : 'user')}
                        >
                          <div className="mobile-filter-row-title-group">
                            <span className="mobile-filter-row-title">User Name</span>
                            <span className="mobile-filter-row-value">
                              {selectAllTeam || selectedTeams.length === teams.length || selectedTeams.length === 0
                                ? '(All)'
                                : `(${selectedTeams.length})`}
                            </span>
                          </div>
                          <ItemIcon className={`mobile-filter-chevron ${openMobileAccordion === 'user' ? 'expanded' : ''}`} />
                        </div>
                        <div className={`mobile-filter-accordion-wrapper ${openMobileAccordion === 'user' ? 'is-open' : ''}`}>
                          <div className="mobile-filter-accordion-inner">
                            <div className="mobile-filter-accordion-content">
                              <input
                                type="text"
                                placeholder="Search teams"
                                value={userSearchTerm}
                                onChange={handleUserSearchChange}
                                className="mobile-filter-search-input"
                                disabled={teamLoading}
                              />
                              <div className="mobile-filter-options-list">
                                {filteredUsers.length > 0 && (
                                  <>
                                    {userSearchTerm === "" && (
                                      <label className="mobile-filter-checkbox-item">
                                        <input
                                          type="checkbox"
                                          checked={selectAllTeam}
                                          onChange={handleSelectAllTeamChange}
                                        />
                                        <span>All Teams</span>
                                      </label>
                                    )}
                                    {filteredUsers.map((team) => (
                                      <label className="mobile-filter-checkbox-item" key={team._id}>
                                        <input
                                          type="checkbox"
                                          checked={selectedTeams.includes(team._id)}
                                          onChange={() => handleCheckboxTeamChange(team._id)}
                                        />
                                        <span>
                                          {team.first_name
                                            ? `${team.first_name} ${team.middle_name ? team.middle_name : ""} ${team.last_name}`
                                            : team.company_first_name
                                              ? `${team.company_first_name} ${team.company_last_name ? team.company_last_name : ""}`
                                              : `${team.company_name} (Company)`}
                                        </span>
                                      </label>
                                    ))}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* 3. Invoice Status */}
                    <div className="mobile-filter-row">
                      <div
                        className="mobile-filter-row-header"
                        onClick={() => setOpenMobileAccordion(openMobileAccordion === 'invoiceStatus' ? null : 'invoiceStatus')}
                      >
                        <div className="mobile-filter-row-title-group">
                          <span className="mobile-filter-row-title">Invoice Status</span>
                          <span className="mobile-filter-row-value">
                            {selectAllStatus || selectedStatus.length === invStatusList.length || selectedStatus.length === 0
                              ? '(All)'
                              : `(${selectedStatus.length})`}
                          </span>
                        </div>
                        <ItemIcon className={`mobile-filter-chevron ${openMobileAccordion === 'invoiceStatus' ? 'expanded' : ''}`} />
                      </div>
                      <div className={`mobile-filter-accordion-wrapper ${openMobileAccordion === 'invoiceStatus' ? 'is-open' : ''}`}>
                        <div className="mobile-filter-accordion-inner">
                          <div className="mobile-filter-accordion-content">
                            <div className="mobile-filter-options-list">
                              {invStatusList.length > 0 && (
                                <>
                                  <label className="mobile-filter-checkbox-item">
                                    <input
                                      type="checkbox"
                                      checked={selectAllStatus}
                                      onChange={handleSelectAllStatusChange}
                                    />
                                    <span>All</span>
                                  </label>
                                  {invStatusList.map((status) => (
                                    <label className="mobile-filter-checkbox-item" key={status._id}>
                                      <input
                                        type="checkbox"
                                        checked={selectedStatus.includes(status._id)}
                                        onChange={() => handleCheckboxStatusChange(status._id)}
                                      />
                                      <span>{status.status}</span>
                                    </label>
                                  ))}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 4. Payment Status */}
                    <div className="mobile-filter-row">
                      <div
                        className="mobile-filter-row-header"
                        onClick={() => setOpenMobileAccordion(openMobileAccordion === 'paymentStatus' ? null : 'paymentStatus')}
                      >
                        <div className="mobile-filter-row-title-group">
                          <span className="mobile-filter-row-title">Payment Status</span>
                          <span className="mobile-filter-row-value">
                            {selectAllPaymentStatus || selectedPaymentStatus.length === invPaymStatusList.length || selectedPaymentStatus.length === 0
                              ? '(All)'
                              : `(${selectedPaymentStatus.length})`}
                          </span>
                        </div>
                        <ItemIcon className={`mobile-filter-chevron ${openMobileAccordion === 'paymentStatus' ? 'expanded' : ''}`} />
                      </div>
                      <div className={`mobile-filter-accordion-wrapper ${openMobileAccordion === 'paymentStatus' ? 'is-open' : ''}`}>
                        <div className="mobile-filter-accordion-inner">
                          <div className="mobile-filter-accordion-content">
                            <input
                              type="text"
                              placeholder="Search payment status"
                              value={paymentStatusSearchTerm}
                              onChange={handlePaymentStatusSearchChange}
                              className="mobile-filter-search-input"
                              disabled={invPaymStatusList.length === 0}
                            />
                            <div className="mobile-filter-options-list">
                              {filteredInvPaymStatusList.length > 0 && (
                                <>
                                  {paymentStatusSearchTerm === "" && (
                                    <label className="mobile-filter-checkbox-item">
                                      <input
                                        type="checkbox"
                                        checked={selectAllPaymentStatus}
                                        onChange={handleSelectAllPaymentStatusChange}
                                      />
                                      <span>All</span>
                                    </label>
                                  )}
                                  {filteredInvPaymStatusList.map((paymentstatus) => (
                                    <label className="mobile-filter-checkbox-item" key={paymentstatus._id}>
                                      <input
                                        type="checkbox"
                                        checked={selectedPaymentStatus.includes(paymentstatus._id)}
                                        onChange={() => handleCheckboxPaymentStatusChange(paymentstatus._id)}
                                      />
                                      <span>{paymentstatus.status}</span>
                                    </label>
                                  ))}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 5. Invoice Type */}
                    <div className="mobile-filter-row">
                      <div
                        className="mobile-filter-row-header"
                        onClick={() => setOpenMobileAccordion(openMobileAccordion === 'invoiceType' ? null : 'invoiceType')}
                      >
                        <div className="mobile-filter-row-title-group">
                          <span className="mobile-filter-row-title">Invoice Type</span>
                          <span className="mobile-filter-row-value">
                            {selectAllInvType || selectedInvTypes.length === 2 || selectedInvTypes.length === 0
                              ? '(All)'
                              : `(${selectedInvTypes.join(', ')})`}
                          </span>
                        </div>
                        <ItemIcon className={`mobile-filter-chevron ${openMobileAccordion === 'invoiceType' ? 'expanded' : ''}`} />
                      </div>
                      <div className={`mobile-filter-accordion-wrapper ${openMobileAccordion === 'invoiceType' ? 'is-open' : ''}`}>
                        <div className="mobile-filter-accordion-inner">
                          <div className="mobile-filter-accordion-content">
                            <div className="mobile-filter-options-list">
                              <label className="mobile-filter-checkbox-item">
                                <input
                                  type="checkbox"
                                  checked={selectAllInvType}
                                  onChange={handleSelectAllInvTypeChange}
                                />
                                <span>All Types</span>
                              </label>
                              <label className="mobile-filter-checkbox-item">
                                <input
                                  type="checkbox"
                                  checked={selectedInvTypes.includes("Regular")}
                                  onChange={() => handleCheckboxInvTypeChange("Regular")}
                                />
                                <span>Regular</span>
                              </label>
                              <label className="mobile-filter-checkbox-item">
                                <input
                                  type="checkbox"
                                  checked={selectedInvTypes.includes("Reimbursement")}
                                  onChange={() => handleCheckboxInvTypeChange("Reimbursement")}
                                />
                                <span>Reimbursement</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 6. Due Date */}
                    <div className="mobile-filter-row">
                      <div
                        className="mobile-filter-row-header"
                        onClick={() => setOpenMobileAccordion(openMobileAccordion === 'dueDate' ? null : 'dueDate')}
                      >
                        <div className="mobile-filter-row-title-group">
                          <span className="mobile-filter-row-title">Due Date</span>
                          <span className="mobile-filter-row-value">
                            {selectedDate ? new Date(selectedDate).toLocaleDateString("en-GB") : '(All)'}
                          </span>
                        </div>
                        <ItemIcon className={`mobile-filter-chevron ${openMobileAccordion === 'dueDate' ? 'expanded' : ''}`} />
                      </div>
                      <div className={`mobile-filter-accordion-wrapper ${openMobileAccordion === 'dueDate' ? 'is-open' : ''}`}>
                        <div className="mobile-filter-accordion-inner">
                          <div className="mobile-filter-accordion-content">
                            <DatePicker
                              oneTap
                              format="dd/MM/yyyy"
                              ranges={ranges}
                              value={selectedDate}
                              onChange={handleDateChange}
                              placement="auto"
                              className="invoice-filter-top-date"
                              isoWeek={appSettings.weekStartDay && appSettings.weekStartDay === 'Monday'}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 7. Issue Date */}
                    <div className="mobile-filter-row">
                      <div
                        className="mobile-filter-row-header"
                        onClick={() => setOpenMobileAccordion(openMobileAccordion === 'issueDate' ? null : 'issueDate')}
                      >
                        <div className="mobile-filter-row-title-group">
                          <span className="mobile-filter-row-title">Issue Date</span>
                          <span className="mobile-filter-row-value">
                            {dateRange ? `${new Date(dateRange[0]).toLocaleDateString("en-GB")} - ${new Date(dateRange[1]).toLocaleDateString("en-GB")}` : '(All Time)'}
                          </span>
                        </div>
                        <ItemIcon className={`mobile-filter-chevron ${openMobileAccordion === 'issueDate' ? 'expanded' : ''}`} />
                      </div>
                      <div className={`mobile-filter-accordion-wrapper ${openMobileAccordion === 'issueDate' ? 'is-open' : ''}`}>
                        <div className="mobile-filter-accordion-inner">
                          <div className="mobile-filter-accordion-content">
                            <input
                              type="text"
                              className="mobile-filter-search-input"
                              value={
                                dateRange
                                  ? `${new Date(dateRange[0]).toLocaleDateString("en-GB")} to ${new Date(dateRange[1]).toLocaleDateString("en-GB")}`
                                  : ''
                              }
                              placeholder="All Time"
                              onClick={toggleModalCalendar}
                              readOnly
                            />
                            {showModalCalendar && (
                              <div className="date-range-new">
                                <Calendar
                                  onCancel={cancelModalCalendar}
                                  onChange={(range) => {
                                    const adjustedStartDate = range.startDate ? new Date(range.startDate) : null;
                                    const adjustedEndDate = range.endDate ? new Date(range.endDate) : null;
                                    onDateChange({
                                      startDate: adjustedStartDate,
                                      endDate: adjustedEndDate,
                                    });
                                  }}
                                  initialRange={{
                                    startDate: dateRange ? new Date(dateRange[0]) : null,
                                    endDate: dateRange ? new Date(dateRange[1]) : null,
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Reset Button */}
                  <button
                    type="button"
                    className="mobile-filters-reset-btn"
                    onClick={clearFilters}
                  >
                    Clear All Filters
                  </button>

                  <Modal
                    className="delete-modal"
                    isOpen={showConfirmationModal}
                    onRequestClose={handleCancel}
                    contentLabel="Confirm Delete"
                    closeTimeoutMS={480}
                  >
                    <div className="delete-modal-content">
                      <h2>Apply or Discard changes?</h2>
                      <p>Do you want to Apply or Discard filter changes?</p>
                      <div className="delete-modal-buttons">
                        <button className="delete" onClick={handleApplyConfirm}>
                          Apply Changes
                        </button>
                        <button onClick={clearFilters}>
                          Discard Changes
                        </button>
                      </div>
                    </div>
                  </Modal>
                </div>
              ) : (
                <div className="new-nodal-invoice-outer-sec">
                  <div className="new-modal-top-sec">
                    <div className="new-modal-heading">
                      All filters
                    </div>
                    <a className="close-image-clr1" onClick={checkAndShowConfirmationModal}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M1 13L13 1" stroke="black" />
                        <path d="M1 0.999999L13 13" stroke="black" />
                      </svg>{" "}
                    </a>
                  </div>
                  <div className="invoice-filter-inner-section">
                    <div className="filter-inner invoice-id">
                      <label htmlFor="fname">Invoice ID</label>
                      <input
                        type="text"
                        onChange={(e) => {
                          setInvoiceNumberFilter(e.target.value);
                          setDebouncedValue(e.target.value);
                          setCurrentPage(1);
                        }}
                        value={invoiceNumberFilter}
                        id="invoiceId"
                        name="invoiceId"
                        placeholder="All"
                      />
                    </div>
                    {user &&
                      (user.userType === userTypeConsts.SUPER_ADMIN ||
                        user.userType === userTypeConsts.ADMIN) && (
                        <div className="filter-inner invoice-status">
                          <label htmlFor="user">User</label>
                          <div className="custom-dropdown1" ref={teamModalDropdownRef}>
                            <div className="drop-down-inner">
                              <div
                                className="selected-options1"
                                onClick={toggleTeamModalDropdown}
                              >
                                {selectedTeams.length === 0 ? (
                                  <div className="placeholder">Select</div>
                                ) : (
                                  <>
                                    <div
                                      className="selected-option1"
                                      key={selectedTeams[0]}
                                    >
                                      {selectedTeams.length === teams.length ? (
                                        `All`
                                      ) : (
                                        <>
                                          <TruncateFilterFieldView
                                            textContent={
                                              teams.find((item) => item._id === selectedTeams[0])?.first_name
                                                ? `${teams.find((item) => item._id === selectedTeams[0]).first_name
                                                } ${teams.find((item) => item._id === selectedTeams[0]).middle_name
                                                  ? teams.find((item) => item._id === selectedTeams[0]).middle_name
                                                  : ""
                                                } ${teams.find(
                                                  (item) => item._id === selectedTeams[0]).last_name
                                                  ? teams.find((item) => item._id === selectedTeams[0]).last_name
                                                  : ""
                                                }`
                                                : teams.find((item) => item._id === selectedTeams[0]).company_first_name
                                                  ? `${teams.find((item) => item._id === selectedTeams[0]).company_first_name
                                                  } ${teams.find((item) => item._id === selectedTeams[0]).company_last_name
                                                    ? teams.find((item) => item._id === selectedTeams[0]).company_last_name
                                                    : ""
                                                  }`
                                                  : `${teams.find((item) => item._id === selectedTeams[0]).company_name} (Company)`
                                            }
                                          />
                                          {selectedTeams.length > 1 &&
                                            selectedTeams.length !==
                                            teams.length && (
                                              <div className="selected-option-count">
                                                {selectedTeams.length - 1}+
                                              </div>
                                            )}
                                        </>
                                      )}
                                    </div>
                                  </>
                                )}
                              </div>
                              {isTeamModalDropdownOpen && (
                                <div className="dropdown-list1">
                                  <input
                                    type="text"
                                    placeholder="Search teams"
                                    value={userSearchTerm}
                                    onChange={handleUserSearchChange}
                                    className="search-bar"
                                    disabled={teamLoading}
                                    style={{
                                      pointerEvents: teamLoading ? "none" : "auto",
                                      opacity: teamLoading ? 0.6 : 1,
                                    }}
                                  />
                                  {teamLoading ? (
                                    <>
                                      {Array.from({ length: 5 }).map((_, index) => (
                                        <label
                                          key={`skeleton-team-modal-${index}`}
                                          className="checkbox-label1"
                                          style={{
                                            pointerEvents: "none",
                                            cursor: "default",
                                          }}
                                        >
                                          <div
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                              backgroundColor: "#e5e7eb",
                                              borderRadius: "3px",
                                              animation: "pulse 1.5s ease-in-out infinite",
                                              flexShrink: 0,
                                            }}
                                          />
                                          <div
                                            style={{
                                              width: "150px",
                                              height: "16px",
                                              backgroundColor: "#e5e7eb",
                                              borderRadius: "4px",
                                              animation: "pulse 1.5s ease-in-out infinite",
                                            }}
                                          />
                                        </label>
                                      ))}
                                    </>
                                  ) : (
                                    <>
                                      {filteredUsers.length > 0 && (
                                        <>
                                          {userSearchTerm === "" && (
                                            <label className="checkbox-label1" key="selectAll" >
                                              <input
                                                type="checkbox"
                                                checked={selectAllTeam}
                                                onChange={handleSelectAllTeamChange}
                                              />
                                              All Teams
                                            </label>
                                          )}
                                          {filteredUsers.map((team) => (
                                            <label className="checkbox-label1" key={team._id} >
                                              <input
                                                type="checkbox"
                                                checked={selectedTeams.includes(team._id)}
                                                onChange={() =>
                                                  handleCheckboxTeamChange(team._id)
                                                }
                                              />
                                              {team.first_name
                                                ? `${team.first_name} ${team.middle_name
                                                  ? team.middle_name
                                                  : ""
                                                } ${team.last_name}`
                                                : team.company_first_name
                                                  ? `${team.company_first_name} ${team.company_last_name
                                                    ? team.company_last_name
                                                    : ""
                                                  }`
                                                  : `${team.company_name} (Company)`}
                                            </label>
                                          ))}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    <div className="filter-inner invoice-status">
                      <label htmlFor="invoiceStatus">Invoice Status</label>
                      <div className="custom-dropdown1" ref={statusModalDropdownRef}>
                        <div className="drop-down-inner">
                          <div
                            className="selected-options1"
                            onClick={toggleStatusModalDropdown}
                          >
                            {selectedStatus.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div
                                  className="selected-option1"
                                  key={selectedStatus[0]}
                                >
                                  {selectedStatus.length ===
                                    invStatusList.length ? (
                                    "All"
                                  ) : (
                                    <>
                                      <TruncateFilterFieldView
                                        textContent={
                                          invStatusList.find(
                                            (item) => item._id === selectedStatus[0]
                                          )?.status
                                        }
                                      />
                                      {selectedStatus.length > 1 &&
                                        selectedStatus.length !==
                                        invStatusList.length && (
                                          <div className="selected-option-count">
                                            {selectedStatus.length - 1}+
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                          {isStatusModalDropdownOpen && (
                            <div className="dropdown-list1">
                              {invStatusList.length > 0 && (
                                <>
                                  <label
                                    className="checkbox-label1"
                                    key="selectAll"
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectAllStatus}
                                      onChange={handleSelectAllStatusChange}
                                    />
                                    All
                                  </label>
                                  {invStatusList.map((status) => (
                                    <label
                                      className="checkbox-label1"
                                      key={status._id}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={selectedStatus.includes(
                                          status._id
                                        )}
                                        onChange={() =>
                                          handleCheckboxStatusChange(status._id)
                                        }
                                      />
                                      {status.status && `${status.status}`}
                                    </label>
                                  ))}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="filter-inner payment-status">
                      <label htmlFor="paymentStatus">Payment Status</label>
                      <div
                        className="custom-dropdown1"
                        ref={paymentStatusModalDropdownRef}
                      >
                        <div className="drop-down-inner">
                          <div
                            className="selected-options1"
                            onClick={togglePaymentStatusModalDropdown}
                          >
                            {selectedPaymentStatus.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div
                                  className="selected-option1"
                                  key={selectedPaymentStatus[0]}
                                >
                                  {selectedPaymentStatus.length ===
                                    invPaymStatusList.length ? (
                                    "All"
                                  ) : (
                                    <>
                                      <TruncateFilterFieldView
                                        textContent={
                                          invPaymStatusList.find(
                                            (item) =>
                                              item._id === selectedPaymentStatus[0]
                                          )?.status
                                        }
                                      />
                                      {selectedPaymentStatus.length > 1 &&
                                        selectedPaymentStatus.length !==
                                        invPaymStatusList.length && (
                                          <div className="selected-option-count">
                                            {selectedPaymentStatus.length - 1}+
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                          {isPaymentStatusModalDropdownOpen && (
                            <div className="dropdown-list1">
                              <input
                                type="text"
                                placeholder="Search payment status"
                                value={paymentStatusSearchTerm}
                                onChange={handlePaymentStatusSearchChange}
                                className="search-bar"
                                disabled={invPaymStatusList.length === 0}
                                style={{
                                  pointerEvents: invPaymStatusList.length === 0 ? "none" : "auto",
                                  opacity: invPaymStatusList.length === 0 ? 0.6 : 1,
                                }}
                              />
                              {invPaymStatusList.length === 0 ? (
                                <>
                                  {Array.from({ length: 5 }).map((_, index) => (
                                    <label
                                      key={`skeleton-payment-status-modal-${index}`}
                                      className="checkbox-label1"
                                      style={{
                                        pointerEvents: "none",
                                        cursor: "default",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "16px",
                                          height: "16px",
                                          backgroundColor: "#e5e7eb",
                                          borderRadius: "3px",
                                          animation: "pulse 1.5s ease-in-out infinite",
                                          flexShrink: 0,
                                        }}
                                      />
                                      <div
                                        style={{
                                          width: "120px",
                                          height: "16px",
                                          backgroundColor: "#e5e7eb",
                                          borderRadius: "4px",
                                          animation: "pulse 1.5s ease-in-out infinite",
                                        }}
                                      />
                                    </label>
                                  ))}
                                </>
                              ) : (
                                <>
                                  {filteredInvPaymStatusList.length > 0 && (
                                    <>
                                      {paymentStatusSearchTerm === "" && (
                                        <label className="checkbox-label1" key="selectAll" >
                                          <input
                                            type="checkbox"
                                            checked={selectAllPaymentStatus}
                                            onChange={handleSelectAllPaymentStatusChange}
                                          />
                                          All
                                        </label>
                                      )}
                                      {filteredInvPaymStatusList.map((paymentstatus) => (
                                        <label
                                          className="checkbox-label1"
                                          key={paymentstatus._id}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={selectedPaymentStatus.includes(
                                              paymentstatus._id
                                            )}
                                            onChange={() =>
                                              handleCheckboxPaymentStatusChange(
                                                paymentstatus._id
                                              )
                                            }
                                          />
                                          {paymentstatus.status &&
                                            `${paymentstatus.status}`}
                                        </label>
                                      ))}
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="filter-inner due-date">
                      <label htmlFor="dueDate" className="calendar-icon">
                        Due Date
                      </label>
                      <div className="date-picker-outer date-picker-outer-all">
                        <div className="custom-picker-icon custom-picker-icon-all">
                          <svg
                            width="1em"
                            height="1em"
                            viewBox="0 0 14 14"
                            fill="currentColor"
                            aria-hidden="true"
                            focusable="false"
                            className="rs-picker-toggle-caret rs-icon"
                            aria-label="calendar"
                            data-category="legacy"
                          >
                            <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                          </svg>
                        </div>
                        <div className="custoom-icon-calender custoom-icon-calender-all">
                          <DatePicker
                            oneTap // Use DatePicker instead of DateRangePicker
                            format="dd/MM/yyyy"
                            ranges={ranges}
                            value={selectedDate}
                            onChange={handleDateChange}
                            placement="auto"
                            className="invoice-filter-top-date"
                            isoWeek={appSettings.weekStartDay && appSettings.weekStartDay === 'Monday'}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="filter-inner invoice-type">
                      <label htmlFor="invoice-type">Invoice Type</label>
                      <div className="custom-dropdown1" ref={invTypeModalDropdownRef}>
                        <div className="drop-down-inner">
                          <div
                            className="selected-options1"
                            onClick={toggleInvTypeModalDropdown}
                          >
                            {selectedInvTypes.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div
                                  className="selected-option1"
                                  key={selectedInvTypes[0]}
                                >
                                  {selectedInvTypes.length === 2
                                    ? "All"
                                    : selectedInvTypes.join(", ")}
                                </div>
                                {selectedInvTypes.length > 1 &&
                                  selectedInvTypes.length !== 2 && (
                                    <div className="selected-option-count">
                                      {selectedInvTypes.length - 1}+
                                    </div>
                                  )}
                              </>
                            )}
                          </div>
                          {isInvTypeModalDropdownOpen && (
                            <div className="dropdown-list1">
                              <label className="checkbox-label1" key="selectAll">
                                <input
                                  type="checkbox"
                                  checked={selectAllInvType}
                                  onChange={handleSelectAllInvTypeChange}
                                />
                                All Types
                              </label>
                              <label className="checkbox-label1" key="Regular">
                                <input
                                  type="checkbox"
                                  checked={selectedInvTypes.includes("Regular")}
                                  onChange={() =>
                                    handleCheckboxInvTypeChange("Regular")
                                  }
                                />
                                Regular
                              </label>
                              <label
                                className="checkbox-label1"
                                key="Reimbursement"
                              >
                                <input
                                  type="checkbox"
                                  checked={selectedInvTypes.includes(
                                    "Reimbursement"
                                  )}
                                  onChange={() =>
                                    handleCheckboxInvTypeChange("Reimbursement")
                                  }
                                />
                                Reimbursement
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="filter-inner due-date">
                      <label htmlFor="dueDate" className="calendar-icon">
                        Issue Date
                      </label>
                      <div
                        className="date-picker-outer date-picker-outer-all"
                        ref={calendarModalRef}
                      >
                        <div className="custom-picker-icon custom-picker-icon-all">
                          <svg
                            width="1em"
                            height="1em"
                            viewBox="0 0 14 14"
                            fill="currentColor"
                            aria-hidden="true"
                            focusable="false"
                            className="rs-picker-toggle-caret rs-icon"
                            aria-label="calendar"
                            data-category="legacy"
                          >
                            <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                          </svg>
                        </div>
                        <div className="custoom-icon-calender custoom-icon-calender-all">
                          <div className="custoom-icon-calender custoom-icon-calender-all custom-date-range">
                            <input
                              type="text"
                              // onChange={}
                              value={
                                dateRange
                                  ? `${new Date(dateRange[0]).toLocaleDateString(
                                    "en-GB",
                                    {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                    }
                                  )} to ${new Date(
                                    dateRange[1]
                                  ).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })}`
                                  : ''
                              }
                              id="invoiceId"
                              name="invoiceId"
                              placeholder="All Time"
                              onClick={toggleModalCalendar}
                              autoComplete="off"
                            />
                          </div>

                          {/* Date range selector */}
                          <div className="date-range-new">
                            {showModalCalendar && (
                              <Calendar
                                onCancel={cancelModalCalendar}
                                onChange={(range) => {
                                  const adjustedStartDate = range.startDate ? new Date(range.startDate) : null;
                                  const adjustedEndDate = range.endDate ? new Date(range.endDate) : null;
                                  onDateChange({
                                    startDate: adjustedStartDate,
                                    endDate: adjustedEndDate,
                                  });
                                }}
                                initialRange={{
                                  startDate: dateRange ? new Date(dateRange[0]) : null,
                                  endDate: dateRange ? new Date(dateRange[1]) : null,
                                }}
                              />
                            )}
                          </div>
                          {/* Date range selector */}
                        </div>
                      </div>
                    </div>
                    <Modal
                      className="delete-modal"
                      isOpen={showConfirmationModal}
                      onRequestClose={handleCancel}
                      contentLabel="Confirm Delete"
                      closeTimeoutMS={480}
                    >
                      <div className="delete-modal-content">
                        <h2>Apply or Discard changes?</h2>
                        <p>
                          Do you want to Apply or Discard filter changes?
                        </p>

                        <div className="delete-modal-buttons">
                          <button className="delete" onClick={handleApplyConfirm} >
                            Apply Changes
                          </button>
                          <button onClick={clearFilters}>
                            Discard Changes
                          </button>
                        </div>
                      </div>
                    </Modal>
                  </div>
                </div>
              )}
              {!isMobileSheet && (
                <div className="filter-buttons">
                  <button className="clear-all" onClick={clearFilters}>Clear All</button>
                  <button className="apply-filter" onClick={applyFilters}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                      <path d="M11.7363 8.81108C11.4276 9.81451 10.4925 10.5444 9.38889 10.5444C8.28471 10.5444 7.35016 9.8141 7.04147 8.81108L0.722221 8.81108C0.323349 8.81108 -1.07845e-06 8.48773 -1.06101e-06 8.08886C-1.04357e-06 7.68998 0.323349 7.36663 0.722221 7.36663L7.04144 7.36663C7.35022 6.3632 8.28529 5.6333 9.38889 5.6333C10.4931 5.6333 11.4276 6.36362 11.7363 7.36663L12.2778 7.36663C12.6767 7.36663 13 7.68998 13 8.08886C13 8.48773 12.6766 8.81108 12.2778 8.81108L11.7363 8.81108ZM9.38889 7.07775C8.83162 7.07775 8.37778 7.53123 8.37778 8.08886C8.37778 8.64613 8.83127 9.09997 9.38889 9.09997C9.94616 9.09997 10.4 8.64648 10.4 8.08886C10.4 7.53158 9.94651 7.07775 9.38889 7.07775Z" fill="white" />
                      <path d="M5.38078 3.17778C5.072 4.18121 4.13693 4.91111 3.03333 4.91111C1.92882 4.91111 0.994035 4.18035 0.68563 3.17687C0.303759 3.15781 -1.07791e-06 2.84216 -1.06101e-06 2.45556C-1.04411e-06 2.06896 0.303748 1.75331 0.685606 1.73425C0.994098 0.730343 1.9294 -4.83911e-07 3.03333 -4.35657e-07C4.13752 -3.87392e-07 5.07206 0.730315 5.38076 1.73333L12.2778 1.73333C12.6767 1.73333 13 2.05668 13 2.45556C13 2.85443 12.6766 3.17778 12.2778 3.17778L5.38078 3.17778ZM3.03333 1.44444C2.47606 1.44444 2.02222 1.89793 2.02222 2.45556C2.02222 3.01283 2.47571 3.46667 3.03333 3.46667C3.5906 3.46667 4.04444 3.01318 4.04444 2.45556C4.04444 1.89828 3.59096 1.44444 3.03333 1.44444Z" fill="white" />
                      <path d="M7.403 14.4444C7.09422 15.4478 6.15916 16.1777 5.05556 16.1777C3.95137 16.1777 3.01682 15.4474 2.70813 14.4444L0.722221 14.4444C0.323349 14.4444 -1.07845e-06 14.121 -1.06101e-06 13.7222C-1.04357e-06 13.3233 0.323349 12.9999 0.722221 12.9999L2.70811 12.9999C3.01689 11.9965 3.95195 11.2666 5.05556 11.2666C6.15974 11.2666 7.09429 11.9969 7.40298 12.9999L12.2778 12.9999C12.6767 12.9999 13 13.3233 13 13.7222C13 14.121 12.6766 14.4444 12.2778 14.4444L7.403 14.4444ZM5.05556 12.711C4.49828 12.711 4.04444 13.1645 4.04444 13.7222C4.04444 14.2794 4.49793 14.7333 5.05556 14.7333C5.61283 14.7333 6.06667 14.2798 6.06667 13.7222C6.06667 13.1649 5.61318 12.711 5.05556 12.711Z" fill="white" />
                    </svg>
                    Apply Filters
                  </button>
                </div>
              )}
            </Modal>
          </div>
          {/* Pulse animation style */}
          <style>{`
            @keyframes pulse {
              0%, 100% {
                opacity: 1;
              }
              50% {
                opacity: 0.5;
              }
            }
          `}</style>
        </div>
        {!isMobile ? (
          <div className="card-outer1">
            <div className={(invoicesFetching && !invoicesLoading) ? "card-outer loading-outer" : "card-outer"}>
              <div className="time-table">
                {/* New Invoice Table */}
                <table style={{ minWidth: "50rem", width: "100%", textAlign: "left" }} className={`${(user.userType === 3 || user.userType === 5 || user.userType === 4 || user.userType === 6 || user.userType === 7) ? "invoice-user-table" : ""} ${(invoicesFetching && !invoicesLoading) ? "loading-fade" : ""}`.trim()}>
                  <thead>
                    <tr>
                      <th style={{ width: "50px", maxWidth: "100px", textAlign: "center", paddingRight: "20px", paddingLeft: "22px" }} className="fixed-se">
                        <input style={{ marginRight: "6px" }} type="checkbox" onChange={handleSelectAllChange} checked={selectAll} />
                      </th>
                      <th className="fixed-sec" style={{ paddingRight: "44px", cursor: "pointer", userSelect: "none" }} onClick={() => handleSort('inv_number')}>
                        Invoice ID<SortIcon field="inv_number" />
                      </th>
                      {(user.userType !== 3 && user.userType !== 5 && user.userType !== 4 && user.userType !== 6 && user.userType !== 7) && (
                        <th className="fixed-se1" style={{ paddingRight: "35px", maxWidth: "230px", minWidth: "230px", width: "230px", cursor: "pointer", userSelect: "none" }} onClick={() => handleSort('inv_for')}>
                          User Name<SortIcon field="inv_for" />
                        </th>
                      )}
                      <th className="fixed-sec2" style={{ paddingRight: "44px", whiteSpace: "nowrap", cursor: "pointer", userSelect: "none" }} onClick={() => handleSort('inv_due_date')}>
                        Due Date<SortIcon field="inv_due_date" />
                      </th>
                      <th className="fixed-sec3" style={{ paddingRight: "45px", minWidth: "121.73px", paddingLeft: "16px" }}></th>
                      <th style={{ paddingRight: "44px", cursor: "pointer", userSelect: "none" }} onClick={() => handleSort('inv_status')}>
                        Status<SortIcon field="inv_status" />
                      </th>
                      <th style={{ paddingRight: "44px", cursor: "pointer", userSelect: "none" }} onClick={() => handleSort('inv_payment_status')}>
                        Payment Status<SortIcon field="inv_payment_status" />
                      </th>
                      <th style={{ paddingRight: "44px", cursor: "pointer", userSelect: "none" }} onClick={() => handleSort('inv_total_amount')}>
                        Amount<SortIcon field="inv_total_amount" />
                      </th>
                      <th style={{ paddingRight: "44px", cursor: "pointer", userSelect: "none" }} onClick={() => handleSort('inv_created_at')}>
                        Creation Date<SortIcon field="inv_created_at" />
                      </th>
                      <th style={{ paddingRight: "44px", maxWidth: "230px", minWidth: "230px", width: "230px", cursor: "pointer", userSelect: "none" }} onClick={() => handleSort('inv_created_by')}>
                        Created By<SortIcon field="inv_created_by" />
                      </th>
                      <th style={{ paddingRight: "44px", maxWidth: "230px", minWidth: "230px", width: "230px", cursor: "pointer", userSelect: "none" }} onClick={() => handleSort('inv_approved_by')}>
                        Updated by<SortIcon field="inv_approved_by" />
                      </th>
                      <th style={{ paddingRight: "44px" }}>Paid Date</th>
                      <th style={{ paddingRight: "44px", cursor: "pointer", userSelect: "none" }} onClick={() => handleSort('inv_company_name')}>
                        Recipient<SortIcon field="inv_company_name" />
                      </th>
                      <th style={{ paddingRight: "22px" }}>App</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoicesLoading ? (
                      // Show skeleton loader during initial load
                      <InvoiceTableSkeleton
                        rows={rowsPerPage}
                        showUserColumn={user.userType !== 3 && user.userType !== 5 && user.userType !== 4 && user.userType !== 6 && user.userType !== 7}
                      />
                    ) : (
                      <>
                        {products?.map((row, index) => (
                          <tr key={row._id || index} >
                            <td style={{ width: "50px", maxWidth: "100px", textAlign: "center", paddingRight: "20px", paddingLeft: "22px" }} className="fixed-se">
                              {checkboxTemplate(row, index)}
                            </td>
                            <td className="fixed-sec" style={{ paddingRight: "44px" }}>{row.inv_number}</td>
                            {(user.userType !== 3 && user.userType !== 5 && user.userType !== 4 && user.userType !== 6 && user.userType !== 7) && (
                              <td className="fixed-se1" style={{ paddingRight: "35px", maxWidth: "230px", minWidth: "230px", width: "230px" }}>
                                <RenderMemberName rowData={row.inv_for} />
                              </td>)}
                            <td className="fixed-sec2" style={{ paddingRight: "44px", whiteSpace: "nowrap" }}>{moment.tz(moment(row.inv_due_date).format("YYYY-MM-DD"), global.config.getTimeZone()).locale("en-gb").format("MMMM DD, YYYY")}
                            </td>
                            <td className="fixed-sec3" style={{ paddingRight: "45px", minWidth: "121.73px", paddingLeft: "16px" }}>{renderCTA(row)}</td>
                            <td style={{ paddingRight: "44px" }}>{renderStatus(row)}</td>
                            <td style={{ paddingRight: "44px" }}>
                              <PaymentStatusWise
                                inv_payment_details={row.inv_payment_details}
                                invData={row}
                                invoiceId={row.inv_number}
                                createdAt={row.created_at}
                                paymentStatus={row.inv_payment_status}
                              />
                            </td>
                            <td style={{ paddingRight: "44px" }}>{renderAmount(row)}</td>
                            <td style={{ paddingRight: "44px" }}>
                              {moment.tz(row.inv_created_at, global.config.getTimeZone()).locale("en-gb").format("MMMM DD, YYYY")}
                              {/* {createDateConvert(row)} */}
                            </td>
                            <td style={{ paddingRight: "44px", maxWidth: "230px", minWidth: "230px", width: "230px" }}>
                              <RenderMemberName rowData={row.inv_created_by} />
                            </td>
                            <td style={{ paddingRight: "44px", maxWidth: "230px", minWidth: "230px", width: "230px" }}>
                              {row.inv_approved_by ? (
                                <RenderMemberName rowData={row.inv_approved_by} />
                              ) : (
                                "Not Reviewed"
                              )}
                            </td>
                            <td style={{ paddingRight: "44px" }}>
                              <PaymentStatus
                                inv_payment_details={row.inv_payment_details}
                                invData={row}
                                payStatus={row.inv_payment_status}
                              />
                            </td>
                            <td style={{ paddingRight: "44px" }}>
                              {row.inv_company_name || "Any"}
                            </td>
                            <td style={{ paddingRight: "44px" }}>{renderImage(row)}</td>

                          </tr>
                        ))}

                      </>
                    )}
                  </tbody>
                </table>

                {products.length === 0 && !invoicesLoading && !invoicesFetching && (
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 24px", gap: "10px" }}>
                    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="6" y="10" width="32" height="26" rx="3" stroke="#D0D5DD" strokeWidth="2" />
                      <path d="M6 16h32" stroke="#D0D5DD" strokeWidth="2" />
                      <path d="M14 7v6M30 7v6" stroke="#D0D5DD" strokeWidth="2" strokeLinecap="round" />
                      <path d="M13 24h6M13 29h12" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    <p style={{ margin: 0, fontSize: "15px", fontWeight: "500", color: "#282828" }}>No invoices found</p>
                    <p style={{ margin: 0, fontSize: "13px", color: "#96A8BA" }}>Create an invoice to get started.</p>
                  </div>
                )}
              </div>
              {/* Pagination - Show skeleton when loading, otherwise show actual pagination */}
              {invoicesLoading ? (
                <ul className="pagination" style={{ pointerEvents: "none", cursor: "default" }}>
                  <li className="back">
                    <div style={{ width: "50px", height: "28px", backgroundColor: "#e5e7eb", borderRadius: "7px", animation: "pulse 1.5s ease-in-out infinite", border: "1px solid #e5e7eb", margin: "0 5.5px" }} />
                  </li>
                  <li>
                    <div style={{ width: "28px", height: "28px", backgroundColor: "#6479f8", borderRadius: "7px", animation: "pulse 1.5s ease-in-out infinite", opacity: 0.7, border: "1px solid #6479f8", margin: "0 5.5px" }} />
                  </li>
                  <li>
                    <div style={{ width: "28px", height: "28px", backgroundColor: "#e5e7eb", borderRadius: "7px", animation: "pulse 1.5s ease-in-out infinite", border: "1px solid #e5e7eb", margin: "0 5.5px" }} />
                  </li>
                  <li className="ellipsis">
                    <div style={{ width: "28px", height: "28px", backgroundColor: "#e5e7eb", borderRadius: "7px", animation: "pulse 1.5s ease-in-out infinite", border: "1px solid #e5e7eb", margin: "0 5.5px" }} />
                  </li>
                  <li>
                    <div style={{ width: "28px", height: "28px", backgroundColor: "#e5e7eb", borderRadius: "7px", animation: "pulse 1.5s ease-in-out infinite", border: "1px solid #e5e7eb", margin: "0 5.5px" }} />
                  </li>
                  <li className="next">
                    <div style={{ width: "50px", height: "28px", backgroundColor: "#e5e7eb", borderRadius: "7px", animation: "pulse 1.5s ease-in-out infinite", border: "1px solid #e5e7eb", margin: "0 5.5px" }} />
                  </li>
                </ul>
              ) : totalPages > 1 ? (
                <ul className="pagination">
                  {currentPage > 1 && (
                    <li className="back">
                      <button className={currentPage === 1 ? "disabled" : ""} disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)}>
                        Back
                      </button>
                    </li>
                  )}
                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter((page) => page === 1 || page === totalPages || (page >= currentPage - 2 && page <= currentPage + 2))
                    .reduce((acc, page, index, array) => {
                      if (index > 0 && page !== array[index - 1] + 1) {
                        acc.push("...");
                      }
                      acc.push(page);
                      return acc;
                    }, [])
                    .map((item, index) =>
                      item === "..." ? (
                        <li key={`ellipsis-${index}`} className="ellipsis">
                          <button onClick={() => onPageChange(index + (index === 1 ? 1 : 2))}>...</button>
                        </li>
                      ) : (
                        <li key={item} className={currentPage === item ? "active" : ""} >
                          <button onClick={() => onPageChange(item)}>{item}</button>
                        </li>
                      )
                    )}
                  {currentPage < totalPages && (
                    <li className="next">
                      <button className={currentPage === totalPages ? "disabled" : ""} disabled={currentPage === totalPages} onClick={() => onPageChange(currentPage + 1)}>
                        Next
                      </button>
                    </li>
                  )}
                </ul>
              ) : null}
            </div>
          </div>
        ) : (
          /* MOBILE-ONLY VIEW */
          <div className="invoice-outer">
            <div className="card">
              <div className="card-outer-user-mobile">
                <h3 className="all-users-mobile-title">All Invoices</h3>
                <button type="button" className="filters-mobile-btn" onClick={toggleFilterModal}>
                  <span>Filters</span>
                  <FilterIcon width="20" height="17" />
                </button>
              </div>

              <div className="time-table" ref={timeTableRef}>
                <table style={{ textAlign: "left" }} className={`${(invoicesFetching && !invoicesLoading) ? "loading-fade" : ""}`.trim()}>
                  <thead>
                    <tr>
                      <th className="sticky-col" onClick={() => handleSort('inv_number')}>
                        <div className="mobile-header-cell-inner">
                          <span>Invoice ID</span>
                          <MobileSortIcon />
                        </div>
                      </th>
                      {(user.userType !== 3 && user.userType !== 5 && user.userType !== 4 && user.userType !== 6 && user.userType !== 7) && (
                        <th onClick={() => handleSort('inv_for')}>
                          <div className="mobile-header-cell-inner">
                            <span>User Name</span>
                            <MobileSortIcon />
                          </div>
                        </th>
                      )}
                      <th onClick={() => handleSort('inv_due_date')}>
                        <div className="mobile-header-cell-inner">
                          <span>Due Date</span>
                          <MobileSortIcon />
                        </div>
                      </th>
                      <th onClick={() => handleSort('inv_status')}>
                        <div className="mobile-header-cell-inner">
                          <span>Status</span>
                          <MobileSortIcon />
                        </div>
                      </th>
                      <th onClick={() => handleSort('inv_payment_status')}>
                        <div className="mobile-header-cell-inner">
                          <span>Payment Status</span>
                          <MobileSortIcon />
                        </div>
                      </th>
                      <th onClick={() => handleSort('inv_total_amount')}>
                        <div className="mobile-header-cell-inner">
                          <span>Amount</span>
                          <MobileSortIcon />
                        </div>
                      </th>
                      <th onClick={() => handleSort('inv_created_at')}>
                        <div className="mobile-header-cell-inner">
                          <span>Creation Date</span>
                          <MobileSortIcon />
                        </div>
                      </th>
                      <th onClick={() => handleSort('inv_created_by')}>
                        <div className="mobile-header-cell-inner">
                          <span>Created By</span>
                          <MobileSortIcon />
                        </div>
                      </th>
                      <th onClick={() => handleSort('inv_approved_by')}>
                        <div className="mobile-header-cell-inner">
                          <span>Updated by</span>
                          <MobileSortIcon />
                        </div>
                      </th>
                      <th>
                        <div className="mobile-header-cell-inner">
                          <span>Paid Date</span>
                        </div>
                      </th>
                      <th onClick={() => handleSort('inv_company_name')}>
                        <div className="mobile-header-cell-inner">
                          <span>Recipient</span>
                          <MobileSortIcon />
                        </div>
                      </th>
                      <th>
                        <div className="mobile-header-cell-inner">
                          <span>App</span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoicesLoading ? (
                      <InvoiceTableSkeleton
                        rows={rowsPerPage}
                        showUserColumn={user.userType !== 3 && user.userType !== 5 && user.userType !== 4 && user.userType !== 6 && user.userType !== 7}
                      />
                    ) : products.length === 0 ? (
                      <tr>
                        <td colSpan={(user.userType !== 3 && user.userType !== 5 && user.userType !== 4 && user.userType !== 6 && user.userType !== 7) ? 13 : 12}>
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 24px", gap: "10px" }}>
                            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="6" y="10" width="32" height="26" rx="3" stroke="#D0D5DD" strokeWidth="2" />
                              <path d="M6 16h32" stroke="#D0D5DD" strokeWidth="2" />
                              <path d="M14 7v6M30 7v6" stroke="#D0D5DD" strokeWidth="2" strokeLinecap="round" />
                              <path d="M13 24h6M13 29h12" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                            <p style={{ margin: 0, fontSize: "15px", fontWeight: "500", color: "#282828" }}>No invoices found</p>
                            <p style={{ margin: 0, fontSize: "13px", color: "#96A8BA" }}>Create an invoice to get started.</p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      products.map((row, index) => (
                        <tr key={row._id || index}>
                          <td className="sticky-col">
                            <Link to={`../invoice/view/${row._id}`} className="invoice-id-cell" style={{ textDecoration: 'none', color: '#1E293B', background: 'transparent', backgroundColor: 'transparent', border: 'none', borderRadius: 0, padding: 0, margin: 0, boxShadow: 'none' }}>
                              <span className="inv-num-text">{row.inv_number}</span>
                              <span className="mobile-chevron-icon">
                                <ItemIcon />
                              </span>
                            </Link>
                          </td>
                          {(user.userType !== 3 && user.userType !== 5 && user.userType !== 4 && user.userType !== 6 && user.userType !== 7) && (
                            <td className="user-name-cell">
                              <RenderMemberName rowData={row.inv_for} />
                            </td>
                          )}
                          <td>
                            {moment.tz(moment(row.inv_due_date).format("YYYY-MM-DD"), global.config.getTimeZone()).locale("en-gb").format("MMMM DD, YYYY")}
                          </td>
                          <td>{renderStatus(row)}</td>
                          <td>
                            <PaymentStatusWise
                              inv_payment_details={row.inv_payment_details}
                              invData={row}
                              invoiceId={row.inv_number}
                              createdAt={row.created_at}
                              paymentStatus={row.inv_payment_status}
                            />
                          </td>
                          <td>{renderAmount(row)}</td>
                          <td>
                            {moment.tz(row.inv_created_at, global.config.getTimeZone()).locale("en-gb").format("MMMM DD, YYYY")}
                          </td>
                          <td>
                            <RenderMemberName rowData={row.inv_created_by} />
                          </td>
                          <td>
                            {row.inv_approved_by ? (
                              <RenderMemberName rowData={row.inv_approved_by} />
                            ) : (
                              "Not Reviewed"
                            )}
                          </td>
                          <td>
                            <PaymentStatus
                              inv_payment_details={row.inv_payment_details}
                              invData={row}
                              payStatus={row.inv_payment_status}
                            />
                          </td>
                          <td>{row.inv_company_name || "Any"}</td>
                          <td>{renderImage(row)}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Mobile Pagination */}
              {invoicesLoading ? (
                <ul className="pagination" style={{ pointerEvents: "none", cursor: "default" }}>
                  <li className="back">
                    <div style={{ width: "50px", height: "28px", backgroundColor: "#e5e7eb", borderRadius: "7px", animation: "pulse 1.5s ease-in-out infinite", margin: "0 5.5px" }} />
                  </li>
                  <li>
                    <div style={{ width: "28px", height: "28px", backgroundColor: "#6479f8", borderRadius: "7px", animation: "pulse 1.5s ease-in-out infinite", opacity: 0.7, margin: "0 5.5px" }} />
                  </li>
                  <li className="next">
                    <div style={{ width: "50px", height: "28px", backgroundColor: "#e5e7eb", borderRadius: "7px", animation: "pulse 1.5s ease-in-out infinite", margin: "0 5.5px" }} />
                  </li>
                </ul>
              ) : totalPages > 1 ? (
                <ul className="pagination">
                  {currentPage > 1 && (
                    <li className="back">
                      <button className={currentPage === 1 ? "disabled" : ""} disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)}>
                        Back
                      </button>
                    </li>
                  )}
                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter((page) => page === 1 || page === totalPages || (page >= currentPage - 2 && page <= currentPage + 2))
                    .reduce((acc, page, index, array) => {
                      if (index > 0 && page !== array[index - 1] + 1) {
                        acc.push("...");
                      }
                      acc.push(page);
                      return acc;
                    }, [])
                    .map((item, index) =>
                      item === "..." ? (
                        <li key={`ellipsis-${index}`} className="ellipsis">
                          <button onClick={() => onPageChange(index + (index === 1 ? 1 : 2))}>...</button>
                        </li>
                      ) : (
                        <li key={item} className={currentPage === item ? "active" : ""} >
                          <button onClick={() => onPageChange(item)}>{item}</button>
                        </li>
                      )
                    )}
                  {currentPage < totalPages && (
                    <li className="next">
                      <button className={currentPage === totalPages ? "disabled" : ""} disabled={currentPage === totalPages} onClick={() => onPageChange(currentPage + 1)}>
                        Next
                      </button>
                    </li>
                  )}
                </ul>
              ) : null}
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};
export default Invoices2;